/* eslint-disable camelcase */
import React, { useEffect, useState, useRef } from "react";
import {
  Button,
  Card,
  DragAndDrop,
  Form,
  FormError,
  FormRow,
  FormRowItem,
  MaterialAutocompleteInput,
  Modal,
  OutlinedContainer,
  TextInput,
  Toast,
} from "@tphglobal/components";
import {
  brand,
  brandColour,
  greyScaleColour,
  otherColour,
} from "@tphglobal/common/theme/style.palette";
import { Grid } from "@mui/material";
import { fontSize, fontWeight } from "@tphglobal/common/theme/style.typography";
import Table from "@tphglobal/components/table";
import { useFormReducer, usePopupReducer } from "@tphglobal/common/hooks";
import DateInput from "@tphglobal/components/materialDateInput";
import {
  FixedTitle,
  HttpMethods,
  mapProductionNameToOption,
  openInNewTab,
} from "@tphglobal/common/utils";
import EditOutlineIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import { useLocation } from "react-router-dom";
import moment, { Moment } from "moment";
import TextSnippetOutlinedIcon from "@mui/icons-material/TextSnippetOutlined";
import useWindowSize from "@tphglobal/common/hooks/windowSize";
import { breakpoints } from "@tphglobal/common/theme/style.layout";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useDispatch, useSelector } from "react-redux";
import { goBack } from "connected-react-router";
import { RegionTypes } from "@tphglobal/common/utils/constants";
import { toast } from "react-toastify";
import { Location } from "history";
import { fetchAuthSession } from "aws-amplify/auth";
import UpdateTimeForm from "./updateTimeForm";
import DigitalTimeSheet from "./digitalTimeSheet";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import {
  apiCall,
  fetchUserProfile,
  resultsFetchRequest,
} from "../../redux/actions";
import { ReduxState } from "../../redux/reducers";
import {
  ADD_DOCUMENT_AU,
  ADD_DOCUMENT_UK,
  CREATE_ACTIVITY_LOGS_AU,
  CREATE_ACTIVITY_LOGS_UK,
  CREATE_PRLEMP_AU,
  CREATE_PRLEMP_UK,
  CREATE_TIMECARD_AU,
  CREATE_TIMECARD_UK,
  DELETE_DOCUMENT_AU,
  DELETE_DOCUMENT_UK,
  FETCH_ATTACHMENT_AU,
  FETCH_ATTACHMENT_UK,
  GET_DOCUMENT_LIST_AU,
  GET_DOCUMENT_LIST_UK,
  GET_DT_API_URL_AU,
  GET_DT_API_URL_UK,
  GET_SIGNATURE_AU,
  GET_SIGNATURE_UK,
  GET_SYS_COMPANY_BY_ID_AU,
  GET_SYS_COMPANY_BY_ID_UK,
  GET_USER_DETAILS_AU,
  GET_USER_DETAILS_UK,
  GET_USERS_AUS,
  GET_USERS_UK,
  PREVIEW_PDF_AU,
  PREVIEW_PDF_UK,
  REMOVE_ATTACHMENT_AU,
  REMOVE_ATTACHMENT_UK,
  SEND_EMAIL_AU,
  SEND_EMAIL_UK,
  UPDATE_TIMECARD_AU,
  IMPORT_DAILY_TIMES_AU,
  IMPORT_DAILY_TIMES_UK,
  UPDATE_TIMECARD_STATUS_AU,
  UPDATE_TIMECARD_STATUS_UK,
  UPDATE_TIMECARD_UK,
  UPLOAD_ATTACHMENT_AU,
  UPLOAD_ATTACHMENT_UK,
  GET_UNITS_BY_RANGE_AU,
  GET_UNITS_BY_RANGE_UK,
} from "../../api";
import {
  CompanyDetailedEntity,
  CompanyEntity,
  CustomField,
  DailyTime,
  FieldsPerUnit,
  FileAttachment,
  ProfileState,
  Timecard,
  UnitLocation,
  UnitsByRangeDate,
  Validators,
} from "../../models";
import {
  convertFormValues,
  formatReadableList,
  generateTimeSheetTableData,
  getDefaultWeekDay,
  getIPAddress,
  mapDepartmentNameToOption,
  NewFormValues,
  normalizeCamTime,
  normalizeDateKey,
  normalizeMrtFile,
  parseDelimitedValues,
  toCamelCase,
} from "../../utils/commonFunctions";
import handleApiCall from "../handleApiCall";
import CustomFieldComponent from "./customFieldComponent";
import TimeInputField from "./tableInputs/timeInputField";
import DropListInput from "./tableInputs/dropListInput";
import MultiSelectInput from "./tableInputs/multiSelectInput";
import TextInputField from "./tableInputs/textInputField";
import { required } from "../../utils";
import { Column, Row, StyledHeading } from "./styles";
import { Container, MaterialAutoCompleteWithAddOption } from "../../components";
import messages from "../../messages";
import TimeCardTable from "./mobileView/timeCardTable";
import DigitalTimeSheetMobile from "./mobileView/digitalTimeSheetMobile";
import { hideLoader, showLoader } from "@tphglobal/common/redux/actions";
import {
  CREATED_DATE_FORMAT,
  PERIOD_ENDING_DATE_FORMATS,
  PERIOD_ENDING_DISPLAY_DATE_FORMAT,
  URL_CLEANUP_TIMEOUT_MS,
} from "../../utils/constant";
import configAmplify from "../../config/awsConfig";
import {
  assignUnitFields,
  getFullNotes,
  handleMealBreakLockedRows,
  setLockedRowsAndWeekData,
} from "../../utils/timeCardFunctions";

interface FormFieldValue {
  id: string;
  label: string;
}

interface FormValuesData {
  [key: string]: string | FormFieldValue | Moment | boolean;
}

interface TimeCardResponse {
  message?: string;
  status: boolean;
  result: Timecard;
}

interface AttachmentData {
  filename: string;
  filenameoriginal?: string;
  url?: string;
  content_type?: string;
  content: string;
  encoding: "base64";
  size: string;
}

interface LocationStateData {
  companyListing: CompanyEntity[];
  isUpdate: boolean;
  timeCardListing?: Timecard[];
  updatingCompanyBrief?: CompanyEntity;
  details: Timecard;
}

interface LocationState {
  data: LocationStateData;
}

interface FileAttachmentObject {
  file: FileAttachment;
  fileId: string;
}

interface SignatureObject {
  base64: string;
  url: string;
  isTypedSignature?: boolean;
}
interface Activity {
  date: string;
  msg: string;
}
interface FinalData {
  approver_chain: unknown;
  group_guid: unknown;
  current_approver: unknown;
  approve_status: unknown;
  ChequeNumber: string | null;
  PayslipNote: string | null;
  WorkState: string | null;
  PayWeek: string | null;
  ChartSort: string | null;
  ChartCode: string | null;
  Flags: string | null;
  InternalNotes: string | null;
  PaymentFlags: string | null;
  PeriodEndingDate: string | null;
  submit_email: string;
  ADTimes: unknown;
  PRLTimes: unknown;
  PayTimes: unknown;
  Batch: number;
  Employee: unknown;
  freelanceuser: unknown;
  TenantGuid: string | null;
  comments: unknown[];
  changes: unknown[];
  activities: Activity[];
  senderid: unknown;
  timesheetImage: string | false;
  freelanceuser_signature: string | null;
  freelanceuser_email: string | null;
  EmailAttachments: unknown;
}

interface Screens {
  screen1: boolean;
  screen2: boolean;
  screen3: boolean;
}

interface UnitsByRangeResponse {
  date: number;
  units: UnitLocation[];
}

const defaultValidators: Validators = {
  production: [required(messages?.general?.validations?.productionRequired)],
  periodEnding: [
    required(messages?.general?.validations?.periodEndingRequired),
  ],
  department: [required("")],
  position: [required("")],
};

let validators: Validators = {
  production: [required(messages?.general?.validations?.productionRequired)],
  periodEnding: [
    required(messages?.general?.validations?.periodEndingRequired),
  ],
  department: [required("")],
  position: [required("")],
};

const rightArrowStyles = {
  height: fontSize?.h3,
  width: fontSize?.h3,
  color: brand?.secondaryMain,
};

const iconStyles = {
  height: fontSize?.h4,
  width: fontSize?.h4,
  color: brandColour?.primary100,
};

const importIconStyles = {
  height: fontSize?.h3,
  width: fontSize?.h3,
  color: brandColour?.primary100,
};

// formatting Attachments
const formattedAttachments = (attachments: FileAttachment[]) =>
  attachments?.map((attachment: FileAttachment) => ({
    file: { ...attachment },
    fileId: attachment?.filename,
  }));

const formatTimedCardAttachments = (
  attachment: FileAttachment,
): FileAttachment => {
  const { size, ...rest }: FileAttachment = attachment;
  return rest;
};

const AddTimeCard = () => {
  const reduxDispatch = useDispatch();
  const { width, height } = useWindowSize();

  const location: Location = useLocation<LocationState>();
  const state = location.state as LocationState | undefined;
  const isUpdateForm = state?.data?.isUpdate;
  const timeCardListing: Timecard[] = state?.data?.timeCardListing;
  const timeCardDetails: Timecard = state?.data?.details;
  const companyOptions = state?.data?.companyListing?.map(
    (item: CompanyEntity) => ({
      id: item?.SysCoyGuid,
      label: item?.Name,
    }),
  );
  const selectedRegion = useSelector(
    (state: ReduxState) => state?.profile?.region,
  );
  const userProfile = useSelector((state: ReduxState) => state?.profile);
  const timeOption = userProfile?.TimeOption;
  const isMobile = width <= breakpoints.mobile;

  const [customFields, setCustomFields] = useState<CustomField[]>();
  const [submitting, setSubmitting] = useState<boolean>(true);
  const [yesterdayTimings, setYesterdayTimings] = useState<DailyTime>();
  const [submittingPreview, setSubmittingPreview] = useState<boolean>(true);
  const [submittingTimeCard, setSubmittingTimeCard] = useState<boolean>(true);
  const [uploadFile, setUploadFile] = useState<File>(null);
  const [weekData, setWeekData] = useState<DailyTime[]>([]);
  const [deptOptions, setDeptOptions] = useState<{ name: string }[]>([]);
  const [mealBreakLockedRows, setMealBreakLockedRows] = useState<number[]>([
    0, 0, 0, 0, 0, 0, 0,
  ]);
  const [payAsLockedRows, setPayAsLockedRows] = useState<number[]>([
    0, 0, 0, 0, 0, 0, 0,
  ]);

  const documents = useSelector((state: ReduxState) => state?.results);

  const [selectedCompanyDetails, setSelectedCompanyDetails] =
    useState<CompanyDetailedEntity>();
  const [selectedCompanyBriefDetails, setSelectedCompanyBriefDetails] =
    useState<CompanyEntity>(
      ((location?.state as LocationState)?.data as LocationStateData)
        ?.updatingCompanyBrief,
    );
  const [submitError, setSubmitError] = useState<string>("");
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [files, setFiles] = useState<FileAttachmentObject[]>(
    formattedAttachments(timeCardDetails?.FileAttachments) || [],
  );
  const [submitionAttachments, setSubmitionAttachments] = useState<
    AttachmentData[]
  >([]);
  const [dtApiUrl, setDtApiUrl] = useState<string>();
  const [screenIndex, setScreenIndex] = useState<Screens>({
    screen1: true,
    screen2: false,
    screen3: false,
  });
  const [submitTimeCardScreen, setSubmitTimeCardScreen] =
    useState<boolean>(false);

  const importedTimeCardRef = useRef<string | null>(null);
  const [isImport, setIsImport] = useState(false);
  const {
    visibility: editFormVisibility,
    showPopup: showEditForm,
    hidePopup: hideEditForm,
    metaData: editFormMetadata,
  } = usePopupReducer<{ data: DailyTime; rowIndex: number }>();
  const {
    visibility: digitalFormVisibility,
    showPopup: showDigitalForm,
    hidePopup: hideDigitalForm,
    metaData: DigitalFormMetadata,
  } = usePopupReducer();
  const [showImportPopup, setShowImportPopup] = useState(false);
  const [pendingImportCard, setPendingImportCard] = useState<Timecard | null>(
    null,
  );
  const [pendingDocumentGuid, setPendingDocumentGuid] = useState<string | null>(
    null,
  );
  const [pendingPdfFileName, setPendingPdfFileName] = useState<string | null>(
    null,
  );
  const [unitsByRange, setUnitsByRange] = useState<UnitsByRangeDate[]>([]);
  const {
    handleSubmit,
    connectField,
    change,
    formValues,
    addPristine,
    resetSpecific,
    pristine,
  } = useFormReducer(validators);

  const importSubmittedTimeCard = (timeCard: Timecard) => {
    importedTimeCardRef.current = timeCard.Guid;
    setIsImport(true);
    const updatedWeekData = timeCard.Times?.[0]?.DailyTimes || [];
    setLockedRowsAndWeekData(
      updatedWeekData,
      setMealBreakLockedRows,
      setPayAsLockedRows,
      setWeekData,
    );

    if (selectedCompanyDetails?.departments) {
      change("departments", {
        id: timeCard.Dept,
        label: timeCard.Dept,
      });
    } else {
      change("department", timeCard.Dept);
    }

    change("position", timeCard.Position);

    timeCard.CustomTimeCardFields?.forEach((field) => {
      change(toCamelCase(field.Prompt), field.Value);
    });

    setSubmitting(false);
    setSubmittingPreview(false);
    setSubmittingTimeCard(false);
  };

  const onCancelEditForm = () => {
    const rowIndex = editFormMetadata?.rowIndex || 0;
    const weekDateData = weekData?.[rowIndex];
    setPayAsLockedRows((prev) => {
      const updated = [...prev];
      updated[rowIndex] =
        weekDateData?.Unit && weekDateData?.Payas !== "0" ? 1 : 0;
      return updated;
    });
    handleMealBreakLockedRows(
      weekDateData as FieldsPerUnit,
      rowIndex,
      setMealBreakLockedRows,
    );
  };

  const resetImportedTimeCardState = () => {
    importedTimeCardRef.current = null;
    setIsImport(false);
    setWeekData([]);
    setFiles([]);
    setSubmitionAttachments([]);

    if (selectedCompanyBriefDetails?.Dept) {
      if (selectedCompanyDetails?.departments) {
        change("departments", {
          id: selectedCompanyBriefDetails?.Dept,
          label: selectedCompanyBriefDetails?.Dept,
        });
      } else {
        change("department", selectedCompanyBriefDetails?.Dept);
      }
    } else {
      change("department", null);
      change("departments", null);
    }

    change("position", selectedCompanyBriefDetails?.Position || null);

    selectedCompanyDetails?.CustomFields?.forEach((field: CustomField) => {
      let defaultValue = field?.Value;

      if (field.Type === "Checkbox") {
        defaultValue = field?.Value === "1" ? "1" : null;
      }

      change(toCamelCase(field.Prompt), defaultValue ?? null);
    });
  };

  const isSamePeriodEnding = (
    tcPeriodEnding: string | number,
    selectedPeriodEnding: Moment,
  ) => {
    const tcMoment =
      typeof tcPeriodEnding === "number"
        ? moment(tcPeriodEnding)
        : moment(tcPeriodEnding, PERIOD_ENDING_DATE_FORMATS, true);

    if (!tcMoment.isValid()) return false;

    return tcMoment
      .startOf("day")
      .isSame(selectedPeriodEnding.clone().startOf("day"));
  };

  const findSubmittedTimeCardForPeriod = (
    companyGuid: string,
    selectedPeriodEnding: Moment,
  ): Timecard | null => {
    if (!companyGuid || !selectedPeriodEnding || !timeCardListing?.length) {
      return null;
    }

    return (
      timeCardListing.find(
        (tc) =>
          tc.Company?.[0]?.Guid === companyGuid &&
          tc.Type === "submitted" &&
          isSamePeriodEnding(tc.PeriodEnding, selectedPeriodEnding),
      ) || null
    );
  };

  const handlePeriodEndingChange = async (value: Moment) => {
    // Update the form value
    change("periodEnding", value);

    const companyGuid = selectedCompanyBriefDetails?.Guid;
    if (!companyGuid) return;

    const submittedCard = findSubmittedTimeCardForPeriod(companyGuid, value);
    if (submittedCard) {
      const doc = documents?.results?.find(
        (d: any) =>
          d.TimecardGuid === submittedCard.Guid && d.DocType === "Timecard",
      );
      setPendingImportCard(submittedCard);
      setPendingDocumentGuid(doc?.Guid || null);
      setPendingPdfFileName(doc?.url || null);
      setShowImportPopup(true);
    } else {
      resetImportedTimeCardState();
    }
    const params = {
      fpGuid: selectedCompanyBriefDetails?.SysCoyGuid,
      startDate: moment(value).subtract(8, "days").valueOf(),
      endDate: value?.valueOf(),
    };
    await fetchUnitsByRange(params);
  };

  const fetchUnitsByRange = async (params: {
    fpGuid: string;
    startDate: number;
    endDate: number;
  }) => {
    try {
      const baseEndpoint =
        selectedRegion === RegionTypes.AU
          ? GET_UNITS_BY_RANGE_AU
          : GET_UNITS_BY_RANGE_UK;
      const endpoint = buildUrlWithQueryParams(baseEndpoint, params);
      reduxDispatch(showLoader());
      await handleApiCall(
        reduxDispatch,
        endpoint,
        (res: any) => {
          if (res?.status) {
            const formatted = res.result.map((item: UnitsByRangeResponse) => ({
              ...item,
              units: item.units.map((unit) => {
                const fullNotes = getFullNotes(unit.Payas, unit.Note);
                return {
                  ...unit,

                  customNote: fullNotes,
                  MB1ND: unit.MB1ND ? "1" : "0",
                  MB2ND: unit.MB2ND ? "1" : "0",
                  MB3ND: unit.MB3ND ? "1" : "0",
                  Note: unit.Note || null,
                  CamCall: normalizeCamTime(unit.CamCall),
                  CamWrap: normalizeCamTime(unit.CamWrap),
                  StartMeal: normalizeCamTime(unit.StartMeal),
                  StartMeal2: normalizeCamTime(unit.StartMeal2),
                  StartMeal3: normalizeCamTime(unit.StartMeal3),
                  FinishMeal1: normalizeCamTime(unit.FinishMeal1),
                  FinishMeal2: normalizeCamTime(unit.FinishMeal2),
                  FinishMeal3: normalizeCamTime(unit.FinishMeal3),
                  Start: normalizeCamTime(unit.Start),
                  Finish: normalizeCamTime(unit.Finish),
                  TotalHours: normalizeCamTime(unit.TotalHours),
                  TotalMBDed: normalizeCamTime(unit.TotalMBDed),
                  Travel1: normalizeCamTime(unit.Travel1),
                  Travel2: normalizeCamTime(unit.Travel2),
                };
              }),
              date: normalizeDateKey(item.date),
            }));
            setUnitsByRange(formatted);
          }
        },
        HttpMethods.GET,
        getRegion(),
        null,
        null,
        null,
        (error) => {
          console.error("Get units by range → Error", error);
          reduxDispatch(hideLoader());
        },
      );
    } catch (error) {
      console.error("Get units by range → Error", error);
    } finally {
      reduxDispatch(hideLoader());
    }
  };

  const updateTimeCardToDraft = (guid: string) => {
    return new Promise<void>((resolve, reject) => {
      handleApiCall(
        reduxDispatch,
        selectedRegion === RegionTypes.AU
          ? UPDATE_TIMECARD_STATUS_AU
          : UPDATE_TIMECARD_STATUS_UK,
        () => resolve(),
        HttpMethods.PUT,
        getRegion(),
        null,
        { Guid: guid, Type: "Draft" },
        null,
        reject,
      );
    });
  };

  const deleteTimeCardDocument = (docGuid: string) => {
    return new Promise<void>((resolve, reject) => {
      handleApiCall(
        reduxDispatch,
        `${
          selectedRegion === RegionTypes.AU
            ? DELETE_DOCUMENT_AU
            : DELETE_DOCUMENT_UK
        }/${docGuid}`,
        () => resolve(),
        HttpMethods.DELETE,
        getRegion(),
        null,
        null,
        null,
        reject,
      );
    });
  };

  const deleteTimeCardPdf = (fileName: string) => {
    return new Promise<void>((resolve, reject) => {
      handleApiCall(
        reduxDispatch,
        selectedRegion === RegionTypes.AU
          ? REMOVE_ATTACHMENT_AU
          : REMOVE_ATTACHMENT_UK,
        () => resolve(),
        HttpMethods.DELETE,
        getRegion(),
        null,
        { fileName },
        null,
        reject,
      );
    });
  };

  const handleConfirmImport = async () => {
    try {
      reduxDispatch(showLoader());
      await updateTimeCardToDraft(pendingImportCard.Guid);

      if (pendingDocumentGuid) {
        await deleteTimeCardDocument(pendingDocumentGuid);
      }

      if (pendingPdfFileName) {
        await deleteTimeCardPdf(pendingPdfFileName);
      }

      importSubmittedTimeCard(pendingImportCard);
    } catch (err) {
      toast(<Toast type="error" text="Failed to import timecard" />);
    } finally {
      reduxDispatch(hideLoader());
      setShowImportPopup(false);
    }
  };

  const handleCancelImport = () => {
    setShowImportPopup(false);
    setPendingImportCard(null);
    setPendingDocumentGuid(null);
    setPendingPdfFileName(null);
    resetImportedTimeCardState();

    change("periodEnding", null);
  };

  // Custom blur handler for period ending field
  const handlePeriodEndingBlur = () => {
    // No validation logic - just allow any valid calendar date
  };
  // Get region
  const getRegion = (): RegionTypes =>
    selectedRegion === RegionTypes.AU ? RegionTypes.AU : RegionTypes.UK;

  // Get/Set signatures
  const setUserSignature = async (url: string): Promise<string> => {
    const response = await fetch(url);
    const data = await response.blob();
    const metadata = {
      type: "image/jpeg",
    };
    const file = new File([data], "Signature.jpg", metadata);
    const reader = new FileReader();

    return new Promise<string>((resolve, reject) => {
      reader.onload = () => {
        if (reader.result) {
          resolve(reader.result as string);
        } else {
          reject(new Error("Failed to read file."));
        }
      };
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  const fetchSignature = async (url: string) => {
    try {
      const response = await fetch(url);
      if (response.ok) {
        const signature = await setUserSignature(url);
        return { base64: signature, url: response.url };
      }
    } catch (error) {
      reduxDispatch(hideLoader());
      console.error("Error fetching signature:", error);
    }
    return null;
  };

  const getUserSignature = async (signatures: {
    signature?: string;
    typed_signature?: string;
  }): Promise<SignatureObject> => {
    if (selectedCompanyDetails?.disabledTypedSig) {
      const drawnSignature =
        signatures?.signature && (await fetchSignature(signatures?.signature));
      if (drawnSignature) {
        return { ...drawnSignature, isTypedSignature: false };
      } else {
        reduxDispatch(hideLoader());
        toast(<Toast type="error" text={"Drawn Signature required"} />);
        return { base64: "", url: "" };
      }
    } else {
      const typedSignature =
        signatures?.typed_signature &&
        (await fetchSignature(signatures?.typed_signature));
      if (typedSignature) {
        return { ...typedSignature, isTypedSignature: true };
      }

      const drawnSignature =
        signatures?.signature && (await fetchSignature(signatures?.signature));
      if (drawnSignature) {
        return { ...drawnSignature, isTypedSignature: false };
      }
      reduxDispatch(hideLoader());
      toast(<Toast type="error" text={"Signature required"} />);
      return { base64: "", url: "" };
    }
  };

  //Fetch attachments
  const fetchEmailAttachments = async () => {
    if (files?.length === 0) return;
    const attachmentPromises = files.map(
      async (attachment: FileAttachmentObject) => {
        const ext = attachment?.file?.url?.split(".").pop();
        const sanitizedBody = {
          fileName: `${attachment?.file?.url?.split("-")[0]}.${ext}`,
        };

        return new Promise<AttachmentData>((resolve, reject) => {
          handleApiCall(
            reduxDispatch,
            getRegion() === RegionTypes.AU
              ? FETCH_ATTACHMENT_AU
              : FETCH_ATTACHMENT_UK,
            async (res) => {
              if (res?.status) {
                try {
                  let fetchData = await fetch(res.result);
                  let data = await fetchData.blob();
                  const metadata = {
                    type: attachment?.file?.ContentType,
                  };
                  let file = new File(
                    [data],
                    attachment?.file?.filename,
                    metadata,
                  );
                  const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);

                  const reader = new FileReader();
                  reader.readAsDataURL(file);
                  reader.onload = () => {
                    const attachmentData: AttachmentData = {
                      filename: `${
                        attachment?.file?.url?.split("-")[0]
                      }.${ext}`,
                      filenameoriginal: attachment?.fileId,
                      content_type: attachment?.file?.ContentType,
                      content:
                        reader.result
                          ?.toString()
                          .replace(/^data:.+;base64,/, "") || "",
                      encoding: "base64",
                      size: sizeInMB,
                      url: res.result,
                    };
                    resolve(attachmentData);
                  };
                  reader.onerror = reject;
                } catch (error) {
                  reject(error);
                }
              } else {
                reject(new Error("Failed to fetch attachment"));
              }
            },
            HttpMethods.POST,
            getRegion(),
            null,
            sanitizedBody,
          );
        });
      },
    );

    try {
      const attachmentsData = await Promise.all(attachmentPromises);
      setSubmitionAttachments(attachmentsData);
    } catch (error) {
      console.error("Error fetching attachments:", error);
    }
  };

  useEffect(() => {
    fetchEmailAttachments();
    reduxDispatch(
      resultsFetchRequest(
        selectedRegion === RegionTypes.AU
          ? GET_DOCUMENT_LIST_AU
          : GET_DOCUMENT_LIST_UK,
        { page: 1, limit: 100 },
      ),
    );
  }, []);
  // Create activity
  const handleCreateActivityLog = async (message?: string) => {
    const ipAddress = await getIPAddress();

    const sanitizedBody = {
      Description: message
        ? message
        : `Timecard has been ${isImport || isUpdateForm ? "updated" : "created"}`,
      IPAddress: ipAddress,
      Type: selectedCompanyDetails.Name,
    };
    handleApiCall(
      reduxDispatch,
      selectedRegion === RegionTypes.AU
        ? CREATE_ACTIVITY_LOGS_AU
        : CREATE_ACTIVITY_LOGS_UK,
      () => {
        setSubmitting(false);
      },
      HttpMethods?.POST,
      getRegion(),
      null,
      sanitizedBody,
    );
  };

  // Validate week data
  const validateWeekData = (isSubmit = false): string | false => {
    if (!weekData) return false;
    const daysWithMissingPayAs: string[] = [];
    // Check for negative total hours first
    const daysWithNegativeHours: string[] = [];
    weekData.forEach((day: DailyTime) => {
      const totalHoursStr = day.TotalHours || "00:00";
      const [hours, minutes] = totalHoursStr.split(":").map(Number);
      const totalDayMinutes = hours * 60 + minutes;
      const hasPayAsValue = !!day?.Payas && day?.Payas !== "0";

      if (totalDayMinutes > 0 && !hasPayAsValue) {
        daysWithMissingPayAs.push(day.Day);
      }

      if (totalDayMinutes < 0) {
        daysWithNegativeHours.push(day.Day);
      }
    });

    if (daysWithNegativeHours.length > 0) {
      const formattedDays = formatReadableList(daysWithNegativeHours);
      return `Negative total hours found for ${formattedDays}`;
    }

    if (daysWithMissingPayAs.length > 0) {
      const dayLabel = daysWithMissingPayAs.length === 1 ? "day" : "days";
      const formattedDays = formatReadableList(daysWithMissingPayAs);
      return `Pay as is required for the following ${dayLabel}: ${formattedDays}`;
    }

    if (isSubmit) {
      // Check for required custom time fields without values, only if TotalHours > 0
      const daysWithMissingFields: string[] = [];
      weekData.forEach((day: DailyTime) => {
        const totalHoursStr = day.TotalHours || "00:00";
        const [hours, minutes] = totalHoursStr.split(":").map(Number);
        const totalDayMinutes = hours * 60 + minutes;

        if (totalDayMinutes > 0) {
          const hasRequiredFieldsWithoutValues = day.CustomTimeFields?.some(
            (field: any) => {
              if (field.required === 1) {
                const hasValue =
                  field.Value && field.Value.toString().trim() !== "";
                return !hasValue;
              }
              return false;
            },
          );

          if (hasRequiredFieldsWithoutValues) {
            daysWithMissingFields.push(day.Day);
          }
        }
      });

      if (daysWithMissingFields.length > 0) {
        return `Required fields missing for ${daysWithMissingFields.join(
          ", ",
        )}`;
      }
    }

    return false; // No validation errors
  };

  // setting initial value on isUpdate
  const getDtAppiUrl = () =>
    new Promise((_, reject) => {
      reduxDispatch(
        apiCall(
          selectedRegion === RegionTypes.AU
            ? GET_DT_API_URL_AU
            : GET_DT_API_URL_UK,
          (res) => {
            if (res?.status) {
              setDtApiUrl(res?.dt_api_url);
            }
          },
          (error) => {
            configAmplify(
              selectedRegion === RegionTypes.AU
                ? RegionTypes.AU
                : RegionTypes.UK,
            );
            fetchAuthSession({ forceRefresh: true });
          },
          HttpMethods.GET,
        ),
      );
    });

  useEffect(() => {
    if (isUpdateForm) {
      change("production", {
        id: timeCardDetails?.SysCoyGuid,
        label: timeCardDetails?.Company[0]?.Name,
      });

      fetchUnitsByRange({
        fpGuid: timeCardDetails?.SysCoyGuid,
        startDate: moment(timeCardDetails?.PeriodEndingTs)
          .subtract(8, "days")
          .valueOf(),
        endDate: moment(timeCardDetails?.PeriodEndingTs).valueOf(),
      });
    }
    getDtAppiUrl();
  }, []);

  // Fetching Selected company details by Id
  const fetchCompanyDetailsById = (companyId: string) => {
    handleApiCall(
      reduxDispatch,
      `${
        selectedRegion === RegionTypes.AU
          ? GET_SYS_COMPANY_BY_ID_AU
          : GET_SYS_COMPANY_BY_ID_UK
      }/${companyId || formValues?.companyId?.value}`,
      (companyObj) => {
        setSelectedCompanyDetails(companyObj?.result);
        setDeptOptions(companyObj?.result?.departments);
        setCustomFields(companyObj?.result?.CustomFields);
      },
      HttpMethods?.GET,
      getRegion(),
    );
  };

  useEffect(() => {
    if (formValues?.production?.value) {
      fetchCompanyDetailsById(formValues?.production?.value?.id);
      const briefCompanyDetailsObject = (
        location?.state as LocationState
      )?.data?.companyListing?.find(
        (company: CompanyEntity) =>
          company?.SysCoyGuid === formValues?.production?.value?.id,
      );

      setSelectedCompanyBriefDetails(briefCompanyDetailsObject);

      // resetting form values on production change
      importedTimeCardRef.current = null;
      setFiles([]);
      setSubmitionAttachments([]);
      setWeekData([]);
      validators = defaultValidators;
      resetSpecific("production");

      // Disabling bottom action buttons when company is changed
      setSubmitting(true);
      setSubmittingPreview(true);
      setSubmittingTimeCard(true);
      setMealBreakLockedRows([0, 0, 0, 0, 0, 0, 0]);
      setPayAsLockedRows([0, 0, 0, 0, 0, 0, 0]);
    }
  }, [formValues?.production?.value]);

  // setting initial field values and validators for the company
  useEffect(() => {
    const newValidators: Validators = { ...validators };
    selectedCompanyDetails?.CustomFields?.forEach((field: CustomField) => {
      if (field?.required === 1) {
        newValidators[toCamelCase(field?.Prompt)] = [
          required("Field cannot be empty, please enter some value."),
        ];
      }
    });

    // Add period ending validation - only require a date, no day-of-week restriction
    if (selectedCompanyDetails?.PayEnding) {
      newValidators.periodEnding = [
        required(messages?.general?.validations?.periodEndingRequired),
      ];
    } else {
      // Reset to default validators if no PayEnding restriction
      newValidators.periodEnding = [
        required(messages?.general?.validations?.periodEndingRequired),
      ];
    }

    if (selectedCompanyDetails?.RequiredFeilds) {
      if (selectedCompanyDetails?.RequiredFeilds?.department) {
        newValidators[
          selectedCompanyDetails?.departments ? "departments" : "department"
        ] = [
          required(
            messages?.general?.validations?.[
              selectedCompanyDetails?.departments
                ? "departmentsRequired"
                : "departmentRequired"
            ],
          ),
        ];
      }
      if (selectedCompanyDetails?.RequiredFeilds?.position) {
        newValidators.position = [
          required(messages?.general?.validations?.positionRequired),
        ];
      }
    }
    validators = newValidators;

    if (
      isUpdateForm &&
      timeCardDetails?.SysCoyGuid === formValues?.production?.value?.id
    ) {
      timeCardDetails?.CustomTimeCardFields?.forEach((field: CustomField) => {
        change(toCamelCase(field?.Prompt), field?.Value);
      });
    } else if (selectedCompanyDetails) {
      selectedCompanyDetails?.CustomFields?.forEach((field: CustomField) => {
        change(toCamelCase(field?.Prompt), field?.Value);
      });
    }
    if (selectedCompanyBriefDetails?.Dept) {
      if (selectedCompanyDetails?.departments) {
        change("departments", {
          id: selectedCompanyBriefDetails?.Dept,
          label: selectedCompanyBriefDetails?.Dept,
        });
      } else {
        change("department", selectedCompanyBriefDetails?.Dept);
      }
    }

    if (isUpdateForm) {
      if (selectedCompanyDetails?.departments && timeCardDetails?.Dept) {
        const set = new Set([
          timeCardDetails?.Dept,
          selectedCompanyBriefDetails?.Dept,
        ]);
        setDeptOptions((prev) => [
          ...prev,
          ...Array.from(set)
            .filter(Boolean)
            .map((item) => ({ name: item })),
        ]);
        change("departments", {
          id: timeCardDetails?.Dept,
          label: timeCardDetails?.Dept,
        });
      } else {
        change("department", timeCardDetails?.Dept);
      }
    }
    addPristine();
  }, [selectedCompanyDetails]);

  useEffect(() => {
    if (
      isUpdateForm &&
      timeCardDetails?.SysCoyGuid === formValues?.production?.value?.id
    ) {
      if (selectedCompanyDetails?.departments) {
        change(
          "departments",
          { id: timeCardDetails?.Dept, label: timeCardDetails?.Dept } || null,
        );
      } else {
        change("department", timeCardDetails?.Dept);
      }
      change("position", timeCardDetails?.Position);
      // change("periodEnding", moment(timeCardDetails?.PeriodEnding));
      // change(
      //   "periodEnding",
      //   moment(timeCardDetails?.PeriodEnding, "DD-MM-YYYY HH:mm:ss")
      // );
      change("periodEnding", moment(timeCardDetails?.PeriodEndingTs));
    } else if (selectedCompanyBriefDetails) {
      change("department", selectedCompanyBriefDetails?.Dept);
      change("position", selectedCompanyBriefDetails?.Position);
      change("periodEnding", null);
      setWeekData(null);
    }
  }, [selectedCompanyBriefDetails, formValues?.production?.value]);

  // Setting calender based on selected date
  useEffect(() => {
    // don't override if timecard is already imported
    if (importedTimeCardRef.current) {
      return;
    }

    if (
      isUpdateForm &&
      // moment(timeCardDetails?.PeriodEnding).format("DD/MM/YYYY") ===
      //   formValues?.periodEnding?.value?.format("DD/MM/YYYY")
      // moment(timeCardDetails?.PeriodEnding, "DD-MM-YYYY HH:mm:ss").format(
      //   "DD/MM/YYYY"
      // ) === formValues?.periodEnding?.value?.format("DD/MM/YYYY")
      moment(timeCardDetails?.PeriodEndingTs).format("DD/MM/YYYY") ===
        formValues?.periodEnding?.value?.format("DD/MM/YYYY")
    ) {
      const updatedWeekData = timeCardDetails?.Times?.[0]?.DailyTimes ?? [];
      setLockedRowsAndWeekData(
        updatedWeekData,
        setMealBreakLockedRows,
        setPayAsLockedRows,
        setWeekData,
      );
    } else if (formValues?.periodEnding?.value) {
      const tableData = generateTimeSheetTableData(
        formValues?.periodEnding?.value,
        selectedCompanyDetails?.PayFrequency,
      );
      const updatedTableData = tableData?.map((day: DailyTime) => ({
        ...day,
        CustomTimeFields: selectedCompanyDetails?.CustomTimeFields || [],
      }));
      const lockedRows = Array(updatedTableData.length).fill(0);
      setMealBreakLockedRows(lockedRows);
      setPayAsLockedRows(lockedRows);
      setWeekData(updatedTableData);
    }

    if (formValues?.periodEnding?.value) {
      setSubmitting(false);
      setSubmittingPreview(false);
      setSubmittingTimeCard(false);
    }
  }, [formValues?.periodEnding?.value]);

  // Functions for forming the body of adding timeCard
  const updateCustomFieldValues = (
    data: FormValuesData,
    customFields: CustomField[],
  ): CustomField[] => {
    const updatedCustomFields = customFields?.map((field) => ({ ...field }));

    const updatedFields = updatedCustomFields?.map((field: CustomField) => {
      const fieldKey = toCamelCase(field?.Prompt);

      let value: string | number | null = null;
      if (data?.[fieldKey]) {
        if (typeof data?.[fieldKey] === "object") {
          value = (data?.[fieldKey] as FormFieldValue)?.label || null;
        } else if (typeof data?.[fieldKey] === "boolean") {
          value = (data?.[fieldKey] as boolean) ? "1" : null;
        } else {
          value = data?.[fieldKey] as string;
        }
      }
      return {
        ...field,
        Value: value,
      };
    });

    return updatedFields;
  };
  const updateFileAttachmentsValue = (): FileAttachment[] => {
    const timeCardAttachments: FileAttachment[] = [];

    files?.forEach((fileObj: FileAttachmentObject) => {
      if (fileObj?.file) {
        const updatedFile: FileAttachment = formatTimedCardAttachments(
          fileObj?.file,
        );

        const updatedFileWithUrl = {
          ...updatedFile,
          url: `${updatedFile?.filename}`,
        };
        timeCardAttachments.push(updatedFileWithUrl);
      }
    });

    return timeCardAttachments;
  };
  const updateEmailAttachmentValue = () => {
    const updatedSubmissionResult = submitionAttachments?.filter(
      (subAttach: AttachmentData) =>
        files?.some(
          (fileObj: FileAttachmentObject) =>
            fileObj?.fileId === subAttach?.filenameoriginal,
        ),
    );

    return updatedSubmissionResult;
  };
  const getTotalHours = (): string => {
    if (!weekData || weekData.length === 0) {
      return "00:00";
    }

    let totalMinutes = 0;
    weekData.forEach((day: DailyTime) => {
      const totalHoursStr = day.TotalHours || "00:00";
      const [hours, minutes] = totalHoursStr.split(":").map(Number);

      const totalDayMinutes = hours * 60 + minutes;

      if (totalDayMinutes >= 0) {
        totalMinutes += totalDayMinutes;
      }
    });

    const totalHours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;

    const formattedTotalHours = String(totalHours).padStart(2, "0");
    const formattedRemainingMinutes = String(remainingMinutes).padStart(2, "0");

    return `${formattedTotalHours}:${formattedRemainingMinutes}`;
  };

  // Uploading attachments
  const handleUploadAttachment = (
    {
      fileName,
      content_type,
      base64Data,
    }: {
      fileName: string;
      content_type: string;
      base64Data: string | ArrayBuffer;
    },
    attachment?: AttachmentData,
    submitCall?: () => void,
  ) => {
    const sanitizedBody = {
      fileName,
      content_type,
      base64Data,
    };
    setShowLoading(true);
    handleApiCall(
      reduxDispatch,
      selectedRegion === RegionTypes.AU
        ? UPLOAD_ATTACHMENT_AU
        : UPLOAD_ATTACHMENT_UK,
      (res) => {
        if (submitCall) {
          submitCall();
          return;
        }
        if (res?.status) {
          setShowLoading(false);

          if (attachment) {
            setSubmitionAttachments((prev: AttachmentData[]) => [
              ...prev,
              attachment,
            ]);
          }
        } else {
          reduxDispatch(hideLoader());
          toast(
            <Toast type="error" text="Error in uploading, Please try again." />,
          );
        }
      },
      HttpMethods.POST,
      getRegion(),
      null,
      sanitizedBody,
      null,
      (errMsg) => {
        setFiles((files: FileAttachmentObject[]) => {
          const res = files?.filter((fileObj: FileAttachmentObject) =>
            submitionAttachments?.some(
              (attachment: AttachmentData) =>
                attachment?.filenameoriginal === fileObj?.fileId,
            ),
          );
          console.log("filtered files", res);

          return res;
        });
        reduxDispatch(hideLoader());
        toast(() => <Toast subText={errMsg} type="error" />);
      },
    );
  };

  const handleUploadFile = async (file: File) => {
    const ext = file?.name.split(".").pop();
    const file_name = files
      ?.find((fileObj: FileAttachmentObject) => fileObj?.fileId === file?.name)
      ?.file?.filename?.split("-")[0];
    const file_name_original = files?.find(
      (fileObj: FileAttachmentObject) => fileObj?.fileId === file?.name,
    )?.fileId;

    const fileName = `${file_name}.${ext}`;
    const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);
    const content_type = file.type;
    const reader = new FileReader();

    const fileReadPromise = new Promise<string>((resolve, reject) => {
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
    });

    reader.readAsDataURL(file);

    const result = await fileReadPromise;

    const attachment: AttachmentData = {
      filename: file_name,
      filenameoriginal: file_name_original,
      content: result.replace(/^data:.+;base64,/, ""),
      content_type: content_type,
      encoding: "base64",
      size: sizeInMB,
    };

    await handleUploadAttachment(
      {
        fileName,
        content_type,
        base64Data: reader.result,
      },
      attachment,
    );
  };
  useEffect(() => {
    if (uploadFile) {
      handleUploadFile(uploadFile);
    }
  }, [uploadFile]);

  useEffect(() => {
    handleApiCall(
      reduxDispatch,
      selectedRegion === RegionTypes.AU
        ? GET_USER_DETAILS_AU
        : GET_USER_DETAILS_UK,
      (data) => {
        reduxDispatch(fetchUserProfile(data));
      },
      HttpMethods?.GET,
      selectedRegion === RegionTypes.AU ? RegionTypes.AU : RegionTypes.UK,
    );
  }, [selectedRegion]);

  const openAttachmentOnClick = (file: any) => {
    const openUrl = submitionAttachments?.find((attachment) => {
      return attachment?.filename?.split(".")[0] == file?.file?.Timestamp;
    })?.url;

    if (openUrl) {
      window.open(openUrl, "_blank");
    }
  };
  // Saving/Updating timeCard
  const onSaveTimeCard = async (data: FormValuesData): Promise<void> => {
    reduxDispatch(showLoader());
    const weekDataValidationResult = validateWeekData(false);
    if (weekDataValidationResult) {
      reduxDispatch(hideLoader());
      toast(<Toast type="error" text={weekDataValidationResult} />);
      return;
    }

    const periodEnding: Moment | undefined = moment.isMoment(data?.periodEnding)
      ? // ? data?.periodEnding
        data?.periodEnding
          ?.clone()
          .hour(moment().hour())
          .minute(moment().minute())
          .second(moment().second())
          .millisecond(moment().millisecond())
      : undefined;

    const sanitizedBody = {
      Activity: timeCardDetails?.Activity ? timeCardDetails?.Activity : "//",
      Company: [
        {
          Guid: selectedCompanyBriefDetails?.Guid,
          Name: selectedCompanyDetails?.Name || null,
          Payas: selectedCompanyDetails?.Payas,
          Production: selectedCompanyDetails?.Production || null,
        },
      ],
      CustomTimeCardFields: updateCustomFieldValues(
        data,
        selectedCompanyDetails?.CustomFields,
      ),
      Dept: selectedCompanyDetails?.departments
        ? (data?.departments as FormFieldValue)?.label || null
        : data?.department || null,
      FileAttachments: updateFileAttachmentsValue(),
      PayFrequency: selectedCompanyDetails?.PayFrequency,
      // PeriodEnding: periodEnding ? periodEnding?.format("YYYY-MM-DD") : null,
      PeriodEnding: periodEnding ? `${periodEnding?.valueOf()}` : null,
      Position: data?.position,
      Times: [
        {
          CustomTimeFields: selectedCompanyDetails?.CustomTimeFields,
          DailyTimes: weekData,
          TotalHours: getTotalHours(),
        },
      ],
      TotalHours: getTotalHours(),
      Type: "Draft",
      SysCoyGuid: selectedCompanyBriefDetails?.SysCoyGuid,
    };

    sanitizedBody?.Company[0]?.Payas?.forEach((item) => {
      if (item.Value === 0) {
        item.Value = "";
      }
    });

    sanitizedBody?.Times[0]?.CustomTimeFields?.forEach((item) => {
      if (item.Value === 0) {
        item.Value = "";
      }
    });

    sanitizedBody?.Times[0]?.DailyTimes?.forEach((item) => {
      item?.CustomTimeFields?.forEach((field) => {
        if (field.Value === 0) {
          field.Value = "";
        }
      });
    });

    const getEndpoint = (): string => {
      const importedGuid = importedTimeCardRef.current;
      if (importedGuid) {
        return selectedRegion === RegionTypes.AU
          ? `${UPDATE_TIMECARD_AU}/${importedGuid}`
          : `${UPDATE_TIMECARD_UK}/${importedGuid}`;
      }

      // NORMAL EDIT MODE
      if (isUpdateForm) {
        return selectedRegion === RegionTypes.AU
          ? `${UPDATE_TIMECARD_AU}/${timeCardDetails?.Guid}`
          : `${UPDATE_TIMECARD_UK}/${timeCardDetails?.Guid}`;
      }

      // CREATE MODE
      return selectedRegion === RegionTypes.AU
        ? CREATE_TIMECARD_AU
        : CREATE_TIMECARD_UK;
    };

    const method =
      isImport || isUpdateForm ? HttpMethods.PUT : HttpMethods.POST;
    setSubmitting(true);

    try {
      await handleApiCall(
        reduxDispatch,
        getEndpoint(),
        () => {
          if (isImport || isUpdateForm) {
            setSubmitting(false);
          }
          handleCreateActivityLog();
          reduxDispatch(hideLoader());
          reduxDispatch(goBack());
        },
        method,
        getRegion(),
        messages?.timeCard?.form?.success?.[
          isImport || isUpdateForm ? "udpateHeading" : "savedHeading"
        ],
        sanitizedBody,
        setSubmitError,
        () => {
          reduxDispatch(hideLoader());
          setSubmitting(false);
        },
      );
    } finally {
      setSubmitting(false);
      reduxDispatch(hideLoader());
    }
  };
  const timeInputField = (
    row: string,
    fieldKey: keyof DailyTime,
    rowIndex: number,
    disabled?: boolean,
  ) => (
    <TimeInputField
      setWeekData={setWeekData}
      fieldKey={fieldKey}
      rowIndex={rowIndex}
      disabled={disabled}
      value={row}
      timeOption={timeOption}
      payAs={selectedCompanyDetails?.Payas || null}
    />
  );
  const dropListField = (
    row: string,
    fieldKey: keyof DailyTime,
    rowIndex: number,
  ) => {
    const list =
      selectedCompanyDetails?.Payas.map((p) => ({
        value: p.Value,
        label: p.Value,
      })) || [];
    return (
      <DropListInput
        setWeekData={setWeekData}
        list={list}
        fieldKey={fieldKey}
        rowIndex={rowIndex}
        periodEnding={formValues?.periodEnding?.value}
        value={row}
        enablePortal={list.length > 0 && payAsLockedRows[rowIndex] !== 1}
      />
    );
  };
  const date = weekData?.[editFormMetadata?.rowIndex || 0]?.Date;
  const selectedUnitByDate = unitsByRange?.find((u) => u.date === date);
  const unitsForDate =
    selectedUnitByDate?.units?.map((u, i) => ({
      value: u.unit,
      label: u.unit,
      id: i + 1,
    })) || [];
  const selectedUnit = weekData?.[editFormMetadata?.rowIndex || 0]?.Unit;
  const selectedLocations =
    weekData?.[editFormMetadata?.rowIndex || 0]?.Locations;

  const locationsForUnit =
    unitsByRange
      ?.find((u) => u.date === date)
      ?.units?.find((u) => u.unit === selectedUnit)
      ?.locations.map((loc, i) => ({ value: loc, label: loc, id: i })) || [];
  const unitListWithEmpty =
    unitsForDate.length > 0
      ? [{ value: null, label: "Select", id: 0 }, ...unitsForDate]
      : [];

  const unitDropListField = (
    row: string,
    fieldKey: keyof DailyTime,
    rowIndex: number,
  ) => {
    const date = weekData?.[rowIndex]?.Date;
    const selectedUnit = unitsByRange?.find((u) => u.date === date);
    const unitsForDate =
      selectedUnit?.units?.map((u) => ({ value: u.unit, label: u.unit })) || [];

    const listWithEmpty =
      unitsForDate.length > 0
        ? [
            {
              value: null,
              label: "Select",
            },
            ...unitsForDate,
          ]
        : [];

    return (
      <DropListInput
        setWeekData={setWeekData}
        list={listWithEmpty}
        fieldKey={fieldKey}
        rowIndex={rowIndex}
        units={selectedUnit?.units}
        periodEnding={formValues?.periodEnding?.value}
        value={row}
        enablePortal={listWithEmpty.length > 0}
        setMealBreakLockedRows={setMealBreakLockedRows}
        setPayAsLockedRows={setPayAsLockedRows}
      />
    );
  };

  const locationDropListField = (
    row: string,
    fieldKey: keyof DailyTime,
    rowIndex: number,
  ) => {
    const date = weekData?.[rowIndex]?.Date;
    const selectedUnit = weekData?.[rowIndex]?.Unit;
    const locationsForUnit =
      unitsByRange
        ?.find((u) => u.date === date)
        ?.units?.find((u) => u.unit === selectedUnit)
        ?.locations.map((loc) => ({ value: loc, label: loc })) || [];

    // Always treat row as comma-separated string
    const valueArray = parseDelimitedValues(row);

    return (
      <MultiSelectInput
        setWeekData={setWeekData}
        list={locationsForUnit}
        fieldKey={fieldKey}
        rowIndex={rowIndex}
        value={valueArray}
        enablePortal={locationsForUnit.length > 0}
        sx={{
          ".MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
        }}
        inputBackgroundColor={"white"}
      />
    );
  };
  const textInputField = (
    row: string,
    fieldKey: keyof DailyTime,
    rowIndex: number,
    readOnly: boolean = false,
  ) => (
    <TextInputField
      fieldKey={fieldKey}
      setWeekData={setWeekData}
      rowIndex={rowIndex}
      value={row}
      readOnly={readOnly}
    />
  );

  // Submitting TimeCard
  const handleUpdateDocumentType = (
    timeCardResponse: TimeCardResponse,
    file_name: string,
  ) => {
    var sanitizedBody = {
      Company: selectedCompanyBriefDetails?.Name,
      ContentType: "application/pdf",
      DocDesc: "Crew Timesheet",
      DocumentType: "PDF",
      Encrypted: "No",
      Filename: file_name,
      Production: selectedCompanyBriefDetails?.Production,
      PWHash: "f56e46w#3fefew",
      Salt: "GYUFYDTFKHFYV",
      url: file_name,
      TimecardGuid: timeCardResponse?.result?.Guid,
      DocType: "Timecard",
    };

    handleApiCall(
      reduxDispatch,
      selectedRegion === RegionTypes.AU ? ADD_DOCUMENT_AU : ADD_DOCUMENT_UK,
      null,
      HttpMethods.POST,
      getRegion(),
      null,
      sanitizedBody,
      null,
      (errMessage: string) => {
        reduxDispatch(hideLoader());
        toast(<Toast type="error" text={errMessage} />);
        setSubmittingTimeCard(false);
      },
    );
  };

  const handleCreateAttachmentDocuments = (
    timeCardResponse: TimeCardResponse,
  ) => {
    const backendAttachments = timeCardResponse?.result?.FileAttachments || [];

    backendAttachments.forEach((file) => {
      const sanitizedBody = {
        Company: selectedCompanyBriefDetails?.Name,
        ContentType: file?.ContentType,
        DocDesc: file.filename,
        DocumentType: file?.ContentType?.includes("pdf") ? "PDF" : "Image",
        Encrypted: "No",
        Filename:
          file.filename.split("-")[0] + "." + file.filename.split(".").pop(),
        url: file.filename.split("-")[0] + "." + file.filename.split(".").pop(),
        Production: selectedCompanyBriefDetails?.Production,
        PWHash: "f56e46w#3fefew",
        Salt: "GYUFYDTFKHFYV",
        TimecardGuid: timeCardResponse?.result?.Guid,
        DocType: "Attachment",
      };

      handleApiCall(
        reduxDispatch,
        selectedRegion === RegionTypes.AU ? ADD_DOCUMENT_AU : ADD_DOCUMENT_UK,
        null,
        HttpMethods.POST,
        getRegion(),
        null,
        sanitizedBody,
      );
    });
  };

  const handleSubmitEmail = (
    timeCardResponse: TimeCardResponse,
    timesheetImage: string,
    email: string,
    data: FormValuesData,
    signatureObj: SignatureObject,
  ) => {
    const filteredAttachmentDocs: AttachmentData[] = submitionAttachments
      ?.filter((doc: AttachmentData) =>
        files?.some(
          (fileObj: FileAttachmentObject) =>
            fileObj?.fileId === doc?.filenameoriginal,
        ),
      )
      ?.map((doc: AttachmentData) => {
        return {
          filename: doc.filenameoriginal,
          content: doc.content,
          encoding: doc.encoding,
          content_type: doc.content_type,
          size: doc.size,
        };
      });

    const periodEndingDate: Moment =
      moment.isMoment(data?.periodEnding) && data?.periodEnding;
    const normalizedMrtFile = normalizeMrtFile(
      selectedCompanyDetails?.Timesheet,
    );

    let sanitizedBody = {
      to: `${email || selectedCompanyBriefDetails?.EmailAddress},${
        userProfile?.EmailAddress
      }`,
      form_data: {
        mrtFile: normalizedMrtFile || "default",
        status: true,
        isTypedSignature: signatureObj?.isTypedSignature,
        items: [
          {
            UserFirstName: userProfile?.FirstName ? userProfile?.FirstName : "",
            UserLastName: userProfile?.LastName ? userProfile?.LastName : "",
            CreatedDate: moment(new Date()).format(CREATED_DATE_FORMAT),
            Activity: "//",
            Company: timeCardResponse?.result?.Company
              ? [
                  {
                    Guid: timeCardResponse?.result?.Company[0]?.Guid,
                    Name: timeCardResponse?.result?.Company[0]?.Name
                      ? timeCardResponse?.result?.Company[0]?.Name
                      : "",
                    Payas: timeCardResponse?.result?.Company[0]?.Payas
                      ? timeCardResponse?.result?.Company[0]?.Payas
                      : "",
                    Production: timeCardResponse?.result?.Company[0]?.Production
                      ? timeCardResponse?.result?.Company[0]?.Production
                      : null,
                  },
                ]
              : [
                  {
                    Guid: selectedCompanyDetails?.Guid,
                    Name: selectedCompanyDetails?.Name
                      ? selectedCompanyDetails?.Name
                      : "",
                    Payas: selectedCompanyDetails?.Payas
                      ? selectedCompanyDetails?.Payas
                      : "",
                    Production: selectedCompanyDetails?.Production
                      ? selectedCompanyDetails?.Production
                      : null,
                  },
                ],
            CustomTimeCardFields: updateCustomFieldValues(
              data,
              selectedCompanyDetails?.CustomFields,
            ),
            Dept: selectedCompanyDetails?.departments
              ? (data?.departments as FormFieldValue)?.label || null
              : data?.department || null,
            FileAttachments: updateFileAttachmentsValue(),
            PayFrequency: selectedCompanyDetails?.PayFrequency,
            PeriodEnding:
              moment.isMoment(data?.periodEnding) &&
              data?.periodEnding?.format("YYYY/MM/DD"),
            PeriodEndingDate: periodEndingDate?.format("YYYY/MM/DD"),
            Position: data?.position,
            EmailTo: selectedCompanyDetails?.EmailAddress,
            IPAddress: getIPAddress(),
            Times: [
              {
                CustomTimeFields: selectedCompanyDetails?.CustomTimeFields,
                DailyTimes: weekData,
                TotalHours: getTotalHours(),
              },
            ],
            TotalHours: getTotalHours(),
            Type: "submitted",
          },
        ],
      },
      AttachmentDocs: filteredAttachmentDocs,
    };
    handleApiCall(
      reduxDispatch,
      selectedRegion === RegionTypes.AU
        ? `${SEND_EMAIL_AU}/${timeCardResponse?.result?.Guid}`
        : `${SEND_EMAIL_UK}/${timeCardResponse?.result?.Guid}`,
      (res) => {
        if (res?.status) {
          handleCreateActivityLog();
          reduxDispatch(hideLoader());
          reduxDispatch(goBack());
        }
      },
      HttpMethods.POST,
      getRegion(),
      messages?.timeCard?.form?.success?.submittedSuccess,
      sanitizedBody,
      null,
      (errorMessage: string) => {
        reduxDispatch(hideLoader());
        toast(<Toast type="error" text={errorMessage} />);
        setSubmittingTimeCard(false);
        hideDigitalForm();
        reduxDispatch(goBack());
      },
    );
  };
  const updateTimeCardStatus = (
    timeCardResponse: TimeCardResponse,
    timesheetImage: string,
    email: string,
    data: FormValuesData,
    signatureObj: SignatureObject,
  ) => {
    const sanitizedBody = {
      Guid: timeCardResponse?.result?.Guid,
      Type: "submitted",
    };
    const file_name = `${new Date().getTime()}.pdf`;
    handleApiCall(
      reduxDispatch,
      selectedRegion === RegionTypes.AU
        ? UPDATE_TIMECARD_STATUS_AU
        : UPDATE_TIMECARD_STATUS_UK,
      (res) => {
        const message = "Timecard has been submitted";
        handleCreateActivityLog(message);
        handleUploadAttachment({
          // fileName,
          fileName: file_name,
          content_type: "application/pdf",
          base64Data: timesheetImage,
        });
        handleUpdateDocumentType(timeCardResponse, file_name);
        handleCreateAttachmentDocuments(timeCardResponse);
        handleSubmitEmail(
          timeCardResponse,
          timesheetImage,
          email,
          data,
          signatureObj,
        );
      },
      HttpMethods.PUT,
      getRegion(),
      null,
      sanitizedBody,
      null,
      (errMessage: string) => {
        reduxDispatch(hideLoader());
        toast(<Toast type="error" text={errMessage} />);
        setSubmittingTimeCard(false);
      },
    );
  };
  const handleCreateprlempOnSubmit = async (
    freelancerData: ProfileState,
    timeCardResponse: TimeCardResponse,
    timesheetImage: string,
    signatureObj: SignatureObject,
    email: string,
    data: FormValuesData,
    timeSheetImageBody: any,
  ) => {
    if (timeCardResponse?.status) {
      const timecarddata = timeCardResponse?.result;

      const Employee: unknown = [];
      const freelanceuser = freelancerData || false;
      const ADTimes: unknown = [];
      const current_approver = "No user";
      const approve_status = "Draft";
      const group_guid: unknown = null;
      const tmp_app: unknown = [];

      const finaldata: FinalData = {
        approver_chain: tmp_app,
        group_guid,
        current_approver,
        approve_status,
        ChequeNumber: null,
        PayslipNote: null,
        WorkState: null,
        PayWeek: null,
        ChartSort: null,
        ChartCode: null,
        Flags: null,
        InternalNotes: null,
        PaymentFlags: null,
        PeriodEndingDate: null,
        ADTimes,
        PRLTimes: timecarddata,
        PayTimes: timecarddata,
        Batch: 1,
        Employee,
        freelanceuser,
        TenantGuid: selectedCompanyBriefDetails?.SysCoyGuid,
        comments: [],
        changes: [],
        submit_email: email,
        activities: [
          {
            date: moment(Date.now()).format("l h:mma"),
            msg: "Timecard created by Freelance Portal.",
          },
        ],
        senderid: null,
        // freelanceuser_signature: signatureObj?.url ? signatureObj?.url : null,
        // timesheetImage: timesheetImage
        //   ? `data:application/pdf;base64,${timesheetImage}`
        //   : false,
        timesheetImage: timeSheetImageBody ? timeSheetImageBody : false,
        freelanceuser_email: userProfile?.EmailAddress
          ? userProfile?.EmailAddress
          : null,
        EmailAttachments: updateEmailAttachmentValue(),
      };

      if (freelancerData) {
        reduxDispatch(
          apiCall(
            selectedRegion === RegionTypes.AU
              ? CREATE_PRLEMP_AU
              : CREATE_PRLEMP_UK,
            (result) => {
              const res = result?.TimecardWebhook_response?.result[0];
              if (res.status === "Success") {
                updateTimeCardStatus(
                  timeCardResponse,
                  timesheetImage,
                  email,
                  data,
                  signatureObj,
                );
              }
            },
            (err) => {
              reduxDispatch(hideLoader());
              toast(
                <Toast
                  type="error"
                  text="Timecard has been saved, but not submitted. Please try again."
                />,
              );
            },
            HttpMethods.POST,
            finaldata,
          ),
        );
      }
    } else {
      reduxDispatch(hideLoader());
      toast(
        <Toast
          type="error"
          text={
            messages?.timeCard?.digitalTimeSheet?.error?.[
              isImport || isUpdateForm
                ? "editTimeCardError"
                : "createTimeCardError"
            ]
          }
        />,
      );
    }
  };
  const handleGetUserOnSubmit = (
    timesheetImage: string,
    timeCardResponse: TimeCardResponse,
    signatureObj: SignatureObject,
    email: string,
    data: FormValuesData,
    timeSheetImageBody: any,
  ) =>
    new Promise((resolve, reject) => {
      reduxDispatch(
        apiCall(
          selectedRegion === RegionTypes.AU ? GET_USERS_AUS : GET_USERS_UK,
          (res) => {
            if (res?.status) {
              handleCreateprlempOnSubmit(
                res?.result,
                timeCardResponse,
                timesheetImage,
                signatureObj,
                email,
                data,
                timeSheetImageBody,
              );
            } else {
              reduxDispatch(hideLoader());
              toast(
                <Toast
                  type="error"
                  text={
                    messages?.timeCard?.digitalTimeSheet?.error?.getUserError
                  }
                />,
              );
            }
          },
          (err) => {
            reduxDispatch(hideLoader());
            toast(
              <Toast
                type="error"
                text={
                  err ||
                  messages?.timeCard?.digitalTimeSheet?.error?.getUserError
                }
              />,
            );
            setSubmittingTimeCard(false);
          },
          HttpMethods.GET,
        ),
      );
    });
  const handlePdfOnSubmit = (
    signatureObj: SignatureObject,
    data: FormValuesData,
    timeCardResponse: TimeCardResponse,
    email: string,
  ) => {
    const periodEnding: Moment =
      moment.isMoment(data?.periodEnding) &&
      data?.periodEnding
        ?.clone()
        .hour(moment().hour())
        .minute(moment().minute())
        .second(moment().second())
        .millisecond(moment().millisecond());
    const periodEndingDate: Moment =
      moment.isMoment(data?.periodEnding) && data?.periodEnding;
    const normalizedMrtFile = normalizeMrtFile(
      selectedCompanyDetails?.Timesheet,
    );
    const sanitizedBody = {
      mrtFile: normalizedMrtFile || "default",
      status: true,
      isTypedSignature: signatureObj?.isTypedSignature,
      items: [
        {
          UserFirstName: userProfile?.FirstName ? userProfile?.FirstName : null,
          UserLastName: userProfile?.LastName ? userProfile?.LastName : null,
          CreatedDate: moment(new Date()).format(CREATED_DATE_FORMAT),
          Activity: timeCardDetails?.Activity || "//",
          Company: timeCardDetails?.Company
            ? [
                {
                  Guid: timeCardDetails?.Company[0].Guid,
                  Name: timeCardDetails?.Company[0].Name
                    ? timeCardDetails?.Company[0].Name
                    : null,
                  Payas: selectedCompanyDetails?.Payas
                    ? selectedCompanyDetails?.Payas
                    : null,
                  Production: selectedCompanyDetails?.Production
                    ? selectedCompanyDetails?.Production
                    : null,
                },
              ]
            : [
                {
                  Guid: selectedCompanyBriefDetails?.Guid,
                  Name: selectedCompanyBriefDetails?.Name
                    ? selectedCompanyBriefDetails?.Name
                    : null,
                  Payas: selectedCompanyDetails?.Payas
                    ? selectedCompanyDetails?.Payas
                    : null,
                  Production: selectedCompanyDetails?.Production
                    ? selectedCompanyDetails?.Production
                    : null,
                },
              ],
          CustomTimeCardFields: updateCustomFieldValues(
            data,
            selectedCompanyDetails?.CustomFields,
          ),
          Dept: selectedCompanyDetails?.departments
            ? (data?.departments as FormFieldValue)?.label || null
            : data?.department || null,
          FileAttachments: updateFileAttachmentsValue(),
          PayFrequency: selectedCompanyDetails?.PayFrequency,
          PeriodEnding: periodEnding ? `${periodEnding?.valueOf()}` : null,
          PeriodEndingDate: periodEndingDate?.format("YYYY/MM/DD"),
          Position: data?.position ? data?.position : null,
          EmailTo: selectedCompanyBriefDetails?.EmailAddress,
          IPAddress: getIPAddress(),
          Times: [
            {
              CustomTimeFields: selectedCompanyDetails?.CustomTimeFields,
              DailyTimes: weekData,
              TotalHours: getTotalHours(),
            },
          ],
          TotalHours: getTotalHours(),
          Type: "submitted",
        },
      ],
    };
    handleApiCall(
      reduxDispatch,
      selectedRegion === RegionTypes.AU ? PREVIEW_PDF_AU : PREVIEW_PDF_UK,
      (response) => {
        if (response.status) {
          handleGetUserOnSubmit(
            response?.pdfData,
            timeCardResponse,
            signatureObj,
            email,
            data,
            sanitizedBody,
          );
        }
      },
      HttpMethods.POST,
      getRegion(),
      null,
      sanitizedBody,
      null,
      (errMessage: string) => {
        reduxDispatch(hideLoader());
        toast(
          <Toast
            type="error"
            text={
              errMessage ||
              messages?.timeCard?.digitalTimeSheet?.error?.createPdfError
            }
          />,
        );
        setSubmittingTimeCard(false);
      },
    );
  };
  const saveEditTimeCardOnSubmit = (
    data: FormValuesData,
    signatureObj: SignatureObject,
    email: string,
  ) => {
    // const periodEnding: Moment =
    //   moment.isMoment(data?.periodEnding) && data?.periodEnding;
    const periodEnding: Moment =
      moment.isMoment(data?.periodEnding) &&
      data?.periodEnding
        ?.clone()
        .hour(moment().hour())
        .minute(moment().minute())
        .second(moment().second())
        .millisecond(moment().millisecond());

    const sanitizedBody = {
      Activity: timeCardDetails?.Activity ? timeCardDetails?.Activity : "//",
      Company: [
        {
          Guid: selectedCompanyBriefDetails?.Guid,
          Name: selectedCompanyDetails?.Name || null,
          Payas: selectedCompanyDetails?.Payas,
          Production: selectedCompanyDetails?.Production || null,
        },
      ],
      CustomTimeCardFields: updateCustomFieldValues(
        data,
        selectedCompanyDetails?.CustomFields,
      ),
      Dept: selectedCompanyDetails?.departments
        ? (data?.departments as FormFieldValue)?.label || null
        : data?.department || null,
      Email: email,
      FileAttachments: updateFileAttachmentsValue(),
      PayFrequency: selectedCompanyDetails?.PayFrequency,
      PeriodEnding: periodEnding ? `${periodEnding?.valueOf()}` : null,
      Position: data?.position || null,
      Times: [
        {
          CustomTimeFields: selectedCompanyDetails?.CustomTimeFields,
          DailyTimes: weekData,
          TotalHours: getTotalHours(),
        },
      ],
      TotalHours: getTotalHours(),
      Type: "Draft",
      SysCoyGuid: selectedCompanyBriefDetails?.SysCoyGuid,
    };

    sanitizedBody?.Company[0]?.Payas?.forEach((item) => {
      if (item.Value === 0) {
        item.Value = "";
      }
    });

    sanitizedBody?.Times[0]?.CustomTimeFields?.forEach((item) => {
      if (item.Value === 0) {
        item.Value = "";
      }
    });

    sanitizedBody?.Times[0]?.DailyTimes?.forEach((item) => {
      item?.CustomTimeFields?.forEach((field) => {
        if (field.Value === 0) {
          field.Value = "";
        }
      });
    });

    const getEndpoint = (): string => {
      const importedGuid = importedTimeCardRef.current;

      // IMPORT MODE ALWAYS WINS
      if (importedGuid) {
        return selectedRegion === RegionTypes.AU
          ? `${UPDATE_TIMECARD_AU}/${importedGuid}`
          : `${UPDATE_TIMECARD_UK}/${importedGuid}`;
      }

      // NORMAL EDIT MODE
      if (isUpdateForm) {
        return selectedRegion === RegionTypes.AU
          ? `${UPDATE_TIMECARD_AU}/${timeCardDetails?.Guid}`
          : `${UPDATE_TIMECARD_UK}/${timeCardDetails?.Guid}`;
      }

      // CREATE MODE
      return selectedRegion === RegionTypes.AU
        ? CREATE_TIMECARD_AU
        : CREATE_TIMECARD_UK;
    };

    const method =
      isImport || isUpdateForm ? HttpMethods.PUT : HttpMethods.POST;
    setSubmitting(true);
    handleApiCall(
      reduxDispatch,
      getEndpoint(),
      (res) => {
        if (res?.status) {
          if (signatureObj?.base64 === "") {
            const errorMessage = selectedCompanyDetails?.disabledTypedSig
              ? "Drawn signature required"
              : "Typed signature required";
            reduxDispatch(hideLoader());
            toast(<Toast type="error" text={errorMessage} />);
            return;
          }
          handlePdfOnSubmit(signatureObj, data, res, email);
        } else {
          reduxDispatch(hideLoader());
          toast(
            <Toast
              type="error"
              text={
                messages?.timeCard?.digitalTimeSheet?.error?.[
                  isImport || isUpdateForm
                    ? "editTimeCardError"
                    : "createTimeCardError"
                ]
              }
            />,
          );
        }
      },
      method,
      getRegion(),
      null,
      sanitizedBody,
      null,
      (errMessage: string) => {
        reduxDispatch(hideLoader());
        toast(<Toast type="error" text={errMessage} />);
        setSubmittingTimeCard(false);
      },
    );
  };

  const handleShowDigitalForm = () => {
    const weekDataValidationResult = validateWeekData(true);
    if (weekDataValidationResult) {
      toast(<Toast type="error" text={weekDataValidationResult} />);
      reduxDispatch(hideLoader());
      return;
    }
    showDigitalForm();
  };

  const onSubmitTimeCard = (email: string) => {
    reduxDispatch(showLoader());
    const weekDataValidationResult = validateWeekData(true);
    if (weekDataValidationResult) {
      toast(<Toast type="error" text={weekDataValidationResult} />);
      setSubmittingTimeCard(false);
      reduxDispatch(hideLoader());
      return;
    }

    const data: NewFormValues = convertFormValues(formValues);

    handleApiCall(
      reduxDispatch,
      selectedRegion === RegionTypes.AU ? GET_SIGNATURE_AU : GET_SIGNATURE_UK,
      async (res) => {
        if (res?.status) {
          const signatureObj: SignatureObject = await getUserSignature(
            res?.result,
          );

          if (!signatureObj?.base64 && !signatureObj?.url) {
            reduxDispatch(hideLoader());
            return;
          }
          saveEditTimeCardOnSubmit(data, signatureObj, email);
        } else {
          reduxDispatch(hideLoader());
          toast(
            <Toast
              type="error"
              text={
                messages?.timeCard?.digitalTimeSheet?.error?.fetchSignatureError
              }
            />,
          );
        }
        setSubmittingPreview(false);
      },
      HttpMethods.GET,
      getRegion(),
      null,
      null,
      null,
      (errMessage: string) => {
        reduxDispatch(hideLoader());
        toast(<Toast type="error" text={errMessage} />);
        setSubmittingTimeCard(false);
      },
    );
  };

  // Preview
  const handlePdf = (signatureObj: SignatureObject, data: FormValuesData) => {
    const periodEnding: Moment =
      moment.isMoment(data?.periodEnding) && data?.periodEnding;
    const periodEndingDate: Moment =
      moment.isMoment(data?.periodEnding) && data?.periodEnding;
    const normalizedMrtFile = normalizeMrtFile(
      selectedCompanyDetails?.Timesheet,
    );

    const sanitizedBody = {
      mrtFile: normalizedMrtFile || "default",
      status: true,
      isTypedSignature: signatureObj?.isTypedSignature,
      items: [
        {
          UserFirstName: userProfile?.FirstName ? userProfile?.FirstName : null,
          UserLastName: userProfile?.LastName ? userProfile?.LastName : null,
          CreatedDate: moment(new Date()).format(CREATED_DATE_FORMAT),
          Activity: timeCardDetails?.Activity || "//",
          Company: timeCardDetails?.Company
            ? [
                {
                  Guid: timeCardDetails?.Company[0].Guid,
                  Name: timeCardDetails?.Company[0].Name
                    ? timeCardDetails?.Company[0].Name
                    : null,
                  Payas: selectedCompanyDetails?.Payas
                    ? selectedCompanyDetails?.Payas
                    : null,
                  Production: selectedCompanyDetails?.Production
                    ? selectedCompanyDetails?.Production
                    : null,
                },
              ]
            : [
                {
                  Guid: selectedCompanyBriefDetails?.Guid,
                  Name: selectedCompanyBriefDetails?.Name
                    ? selectedCompanyBriefDetails?.Name
                    : null,
                  Payas: selectedCompanyDetails?.Payas
                    ? selectedCompanyDetails?.Payas
                    : null,
                  Production: selectedCompanyDetails?.Production
                    ? selectedCompanyDetails?.Production
                    : null,
                },
              ],
          CustomTimeCardFields: updateCustomFieldValues(
            data,
            selectedCompanyDetails?.CustomFields,
          ),
          Dept: selectedCompanyDetails?.departments
            ? (data?.departments as FormFieldValue)?.label || null
            : data?.department || null,
          FileAttachments: updateFileAttachmentsValue(),
          PayFrequency: selectedCompanyDetails?.PayFrequency,
          PeriodEnding: periodEnding?.format("YYYY/MM/DD"),
          PeriodEndingDate: periodEndingDate?.format("YYYY/MM/DD"),
          Position: data?.position ? data?.position : null,
          EmailTo: selectedCompanyBriefDetails?.EmailAddress,
          IPAddress: getIPAddress(),
          Times: [
            {
              // CustomTimeFields: selectedCompanyDetails?.CustomTimeFields,
              DailyTimes: weekData,
              TotalHours: getTotalHours(),
            },
          ],
          TotalHours: getTotalHours(),
          Type: "Draft",
        },
      ],
    };

    sanitizedBody?.items[0]?.Company[0]?.Payas?.forEach((item) => {
      if (item.Value === 0) {
        item.Value = null;
      }
    });

    sanitizedBody?.items[0]?.CustomTimeCardFields?.forEach((item) => {
      if (item.Value === 0) {
        item.Value = null;
      }
    });

    sanitizedBody?.items[0]?.Times[0]?.CustomTimeFields?.forEach((item) => {
      if (item.Value === 0) {
        item.Value = null;
      }
    });

    sanitizedBody?.items[0]?.Times[0]?.DailyTimes?.forEach((item) => {
      item?.CustomTimeFields?.forEach((field) => {
        if (field.Value === 0) {
          field.Value = null;
        }
      });
    });

    handleApiCall(
      reduxDispatch,
      selectedRegion === RegionTypes.AU ? PREVIEW_PDF_AU : PREVIEW_PDF_UK,
      (response) => {
        if (response?.pdfData) {
          reduxDispatch(hideLoader());
          try {
            const byteCharacters = window.atob(response?.pdfData);
            const byteNumbers = new Array(byteCharacters.length)
              .fill(0)
              .map((_, i) => byteCharacters.charCodeAt(i));
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: "application/pdf" });
            const blobUrl = URL.createObjectURL(blob);

            openInNewTab(blobUrl, () => {
              toast(
                <Toast
                  type="error"
                  text="Failed to open the PDF Preview window. Please check your popup blocker."
                />,
              );
            });
            setTimeout(() => {
              URL.revokeObjectURL(blobUrl);
            }, URL_CLEANUP_TIMEOUT_MS);
          } catch (error) {
            toast(
              <Toast
                type="error"
                text={`An error occurred while trying to preview the PDF: ${error}`}
              />,
            );
          }
        } else {
          reduxDispatch(hideLoader());
          toast(
            <Toast type="error" text="No PDF data found in the response." />,
          );
        }
      },
      HttpMethods.POST,
      getRegion(),
      null,
      sanitizedBody,
    );
  };

  const handlePreviewClick = async (data: FormValuesData): Promise<void> => {
    setSubmittingPreview(true);
    reduxDispatch(showLoader());
    const weekDataValidationResult = validateWeekData(true);
    if (weekDataValidationResult) {
      reduxDispatch(hideLoader());
      setSubmittingPreview(false);
      toast(<Toast type="error" text={weekDataValidationResult} />);
      return;
    }
    try {
      await handleApiCall(
        reduxDispatch,
        selectedRegion === RegionTypes.AU ? GET_SIGNATURE_AU : GET_SIGNATURE_UK,
        async (res) => {
          if (res?.status) {
            const signatureObj: SignatureObject = await getUserSignature(
              res?.result,
            );

            if (!signatureObj?.base64 && !signatureObj?.url) {
              reduxDispatch(hideLoader());
              return;
            }
            handlePdf(signatureObj, data);
          }
        },
        HttpMethods.GET,
        getRegion(),
        null,
        null,
        null,
        (errMessage: string) => {
          reduxDispatch(hideLoader());
          toast(<Toast type="error" text={errMessage} />);
          setSubmittingTimeCard(false);
        },
      );
    } finally {
      setSubmittingPreview(false);
    }
  };
  // Copy last weeks data
  const findTimeCard = (SysCoyGuid: string): Timecard | null => {
    let checkDateType = typeof weekData[6]?.Date;
    let periodEndingMoment;

    if (checkDateType === "number") {
      periodEndingMoment = moment(weekData[6]?.Date).format("YYYY-MM-DD");
    } else {
      periodEndingMoment = moment(weekData[6]?.Date, "DD/MM/YYYY").format(
        "YYYY-MM-DD",
      );
    }

    const companyTimeCards = timeCardListing.filter(
      (tc) => tc.Company[0].Guid === SysCoyGuid,
    );

    const periodEndDate = moment(periodEndingMoment, "YYYY-MM-DD");

    const previousWeekTimeCards = companyTimeCards.filter((tc) => {
      const cardDate = moment(
        tc.PeriodEnding,
        PERIOD_ENDING_DATE_FORMATS,
        true,
      );
      const oneWeekBefore = moment(periodEndDate).subtract(1, "week");
      return (
        cardDate.isValid() &&
        cardDate.isBetween(oneWeekBefore, periodEndDate, null, "[]") &&
        (tc.Type === "Draft" || tc.Type === "submitted")
      );
    });

    if (previousWeekTimeCards.length > 0) {
      const sortedTimeCards = previousWeekTimeCards.sort((a, b) =>
        moment(b.PeriodEnding, PERIOD_ENDING_DATE_FORMATS).diff(
          moment(a.PeriodEnding, PERIOD_ENDING_DATE_FORMATS),
        ),
      );

      const submittedCard = sortedTimeCards.find(
        (tc) => tc.Type === "submitted",
      );
      return submittedCard || sortedTimeCards[0];
    }

    const allEarlierTimeCards = companyTimeCards.filter((tc) => {
      const cardDate = moment(
        tc.PeriodEnding,
        PERIOD_ENDING_DATE_FORMATS,
        true,
      );
      return (
        cardDate.isValid() &&
        cardDate.isBefore(periodEndDate) &&
        (tc.Type === "Draft" || tc.Type === "submitted")
      );
    });

    if (allEarlierTimeCards.length > 0) {
      const sortedEarlierTimeCards = allEarlierTimeCards.sort((a, b) =>
        moment(b.PeriodEnding, PERIOD_ENDING_DATE_FORMATS).diff(
          moment(a.PeriodEnding, PERIOD_ENDING_DATE_FORMATS),
        ),
      );
      const submittedEarlierCard = sortedEarlierTimeCards.find(
        (tc) => tc.Type === "submitted",
      );
      return submittedEarlierCard || sortedEarlierTimeCards[0];
    }
  };
  const handleCopyLastWeeksData = () => {
    if (!formValues?.periodEnding?.value) {
      toast(
        <Toast type="error" text={messages?.timeCard?.selectPeriodEnding} />,
      );
      return;
    }

    const companyGuid = selectedCompanyBriefDetails?.Guid;

    const timeCard = findTimeCard(companyGuid);
    const previousWeekTimings = timeCard?.Times[0]?.DailyTimes;
    const mode = userProfile?.CopyLastWeekTimes;

    if (timeCard) {
      const updatedWeekData = previousWeekTimings?.map(
        (dayObj: DailyTime, index: number) => {
          const { Date, Day, Note, customNote, CustomTimeFields, ...rest } =
            dayObj;
          const newDay: any = {
            ...rest,
            Unit: weekData[index]?.Unit,
            Locations: weekData[index]?.Locations,
            CamCall: weekData[index]?.CamCall || "00:00",
            CamWrap: weekData[index]?.CamWrap || "00:00",
            Date: weekData[index]?.Date,
            Day: weekData[index]?.Day,
            Note: null,
            customNote: null,
          };
          if (mode === "COPY_EVERYTHING") {
            newDay.Note = Note;
            newDay.CustomTimeFields = CustomTimeFields;
            // copy customNote ONLY if Payas is Worked
            if (dayObj?.Payas === "Worked") {
              newDay.customNote = customNote;
            } else {
              newDay.customNote = null;
            }
          }
          if (mode === "COPY_HOURS_ONLY") {
            newDay.Note = null;
            newDay.customNote = null;
            newDay.CustomTimeFields = weekData[index]?.CustomTimeFields;
          }
          // PAYAS only if Worked
          if (dayObj?.Payas !== "Worked") {
            newDay.Payas = "0";
          }
          return newDay;
        },
      );

      setLockedRowsAndWeekData(
        updatedWeekData as DailyTime[],
        setMealBreakLockedRows,
        setPayAsLockedRows,
        setWeekData,
        true,
      );
    } else {
      toast(
        <Toast type="error" text={messages?.timeCard?.noTimeCardAvailable} />,
      );
    }
  };

  const buildUrlWithQueryParams = (
    baseUrl: string,
    params: Record<string, string | number | undefined | null>,
  ): string => {
    const query = Object.entries(params)
      .filter(([, value]) => value !== undefined && value !== null)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`,
      )
      .join("&");

    return query ? `${baseUrl}?${query}` : baseUrl;
  };

  const handleImportDailyTimes = async () => {
    if (!formValues?.production?.value || !formValues?.periodEnding?.value) {
      toast(
        <Toast
          type="error"
          text="'Company' and ‘Period Ending’ must be provided to import Daily Times."
        />,
      );
      return;
    }

    try {
      const params = {
        fpGuid: selectedCompanyBriefDetails?.SysCoyGuid,
        periodEnding: formValues?.periodEnding?.value?.valueOf(),
      };

      const baseEndpoint =
        selectedRegion === RegionTypes.AU
          ? IMPORT_DAILY_TIMES_AU
          : IMPORT_DAILY_TIMES_UK;

      const endpoint = buildUrlWithQueryParams(baseEndpoint, params);

      reduxDispatch(showLoader());
      await handleApiCall(
        reduxDispatch,
        endpoint,
        (res: any) => {
          const apiDailyTimes: DailyTime[] =
            res?.result?.response?.dailyTimes || [];
          if (!apiDailyTimes.length) {
            toast(
              <Toast
                type="error"
                text="There are no Daily Times available to import for this period."
              />,
            );
            return;
          }
          const updatedUnitsByRange = [...unitsByRange];

          const mergedWeekData: DailyTime[] = weekData.map(
            (weekDay, rowIndex) => {
              const weekDayKey = normalizeDateKey(weekDay.Date);
              const apiDay = apiDailyTimes.find(
                (d) => normalizeDateKey(d.Date) === weekDayKey,
              );
              if (!apiDay) {
                return weekDay;
              }
              const payas = apiDay?.Payas || weekDay?.Payas;
              const note = apiDay?.Note || weekDay?.Note;

              const fullNotes = getFullNotes(payas, note);
              apiDailyTimes.forEach((apiDay) => {
                const dateKey = normalizeDateKey(apiDay.Date);
                const unit = apiDay.Unit;
                if (unit) {
                  const locations = parseDelimitedValues(apiDay.Locations);

                  let dateEntry = updatedUnitsByRange.find(
                    (u) => u.date === dateKey,
                  );
                  const fullNotes = getFullNotes(apiDay.Payas, apiDay.Note);

                  if (dateEntry) {
                    let unitEntry = dateEntry.units.find(
                      (u) => u.unit === unit,
                    );

                    if (!unitEntry) {
                      // If the unit is not present, add it
                      unitEntry = {
                        unit,
                        locations: [...locations],
                      };
                      assignUnitFields(unitEntry, apiDay, fullNotes);
                      dateEntry.units.push(unitEntry);
                    } else {
                      // Add any missing locations
                      locations.forEach((loc) => {
                        if (!unitEntry?.locations.includes(loc)) {
                          unitEntry?.locations.push(loc);
                        }
                      });
                      assignUnitFields(unitEntry, apiDay, fullNotes);
                    }
                  }
                }
              });

              return {
                ...weekDay,
                ...apiDay,
                Date: weekDay.Date,
                Day: weekDay.Day,
                CustomTimeFields:
                  apiDay.CustomTimeFields ||
                  weekDay.CustomTimeFields ||
                  selectedCompanyDetails?.CustomTimeFields ||
                  [],
                customNote: fullNotes,
              };
            },
          );

          setUnitsByRange(updatedUnitsByRange);
          setLockedRowsAndWeekData(
            mergedWeekData,
            setMealBreakLockedRows,
            setPayAsLockedRows,
            setWeekData,
          );
          setSubmitting(false);
          setSubmittingPreview(false);
          setSubmittingTimeCard(false);
        },
        HttpMethods.GET,
        getRegion(),
        null,
        null,
        null,
        (error) => {
          console.error("Import Daily Times → Error", error);
        },
      );
    } catch (err) {
      console.error("Import Daily Times → Exception", err);
    } finally {
      reduxDispatch(hideLoader());
    }
  };

  const handleCopyYesterdayTimings = () => {
    const currDay: DailyTime = editFormMetadata?.data;
    let lastDay: DailyTime;
    const index = editFormMetadata?.rowIndex;

    if (index === 0) {
      lastDay = getDefaultWeekDay(formValues?.periodEnding?.value);
    } else {
      lastDay = {
        ...weekData[index - 1],
        Unit: currDay?.Unit,
        Locations: currDay?.Locations,
        CamCall: currDay?.CamCall,
        CamWrap: currDay?.CamWrap,
        Date: currDay?.Date,
        Day: currDay?.Day,
        Note: null,
      };
    }
    if (lastDay.Payas === "0") {
      setPayAsLockedRows((prev) => {
        const updated = [...prev];
        updated[index || 0] = 0;
        return updated;
      });
    }
    setYesterdayTimings(lastDay);
  };

  const hasErrorToast = () => {
    toast(
      <Toast
        type="error"
        text={messages?.general?.errors?.requiredFieldsNotFilled}
      />,
    );
  };

  const Screen1 = () => {
    const travelToShown = selectedCompanyDetails?.TravelToHide !== true;
    const travelFromShown = selectedCompanyDetails?.TravelFromHide !== true;
    const hasUnitsAndLocations =
      unitsByRange?.length > 0 &&
      weekData?.some((weekDay) =>
        unitsByRange.some((unitDay) => unitDay.date === weekDay.Date),
      );
    const showCamCallWrap =
      unitsByRange?.length > 0 &&
      weekData?.some((weekDay) => {
        const unitData = unitsByRange.find(
          (unitDay) => unitDay.date === weekDay.Date,
        );

        return (
          unitData &&
          unitData.units.some(
            (data) =>
              weekDay.Unit === data.unit &&
              (data.CamCall !== "00:00" || data.CamWrap !== "00:00"),
          )
        );
      });

    let baseIndex = 2; // Date, Day
    if (hasUnitsAndLocations) baseIndex += 2; // Unit, Locations
    if (hasUnitsAndLocations && showCamCallWrap) baseIndex += 2; // CamCall, CamWrap
    if (travelToShown) baseIndex += 1; // Travel To
    baseIndex += 3; // Start, Meal, Finish
    if (travelFromShown) baseIndex += 1; // Travel From
    baseIndex += 2; // TotalHours
    let payAsIndex = baseIndex;
    let noteIndex = baseIndex + 1;

    return (
      <Container
        showGoBack
        heading={messages?.timeCard?.heading}
        background={otherColour?.adminBg100}
        maxHeight
      >
        <Card
          showGoBack
          noContentPadding={isMobile}
          removeTitle
          contentCss={isMobile && { padding: "0 16px 24px !important" }}
          header={
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item>
                <StyledHeading
                  fontSize={fontSize?.h2}
                  fontWeight={fontWeight?.semiBold}
                >
                  {isImport || isUpdateForm
                    ? messages?.timeCard?.form?.editHeading
                    : messages?.timeCard?.form?.heading}
                </StyledHeading>
              </Grid>
            </Grid>
          }
        >
          <Form onSubmit={handleSubmit(onSaveTimeCard, hasErrorToast)}>
            <OutlinedContainer
              borderRadius="0"
              padding="16px 0 0 0"
              noBorder
              styles={{
                borderTop: `1px solid ${brandColour?.primary10}`,
                borderBottom:
                  !isMobile && `1px solid ${brandColour?.primary10}`,
                marginBottom: "24px",
              }}
            >
              <FormRow>
                <StyledHeading
                  fontSize={fontSize?.h4}
                  fontWeight={fontWeight?.semiBold}
                >
                  {messages?.timeCard?.form?.subHeading}
                </StyledHeading>
              </FormRow>
              <FormRow columnSpacing={2} rowSpacing={2}>
                <FormRowItem lg={3} md={3} sm={6} xs={12}>
                  {connectField("production", {
                    label: messages?.timeCard?.form?.production,
                    options: companyOptions?.map(mapProductionNameToOption),
                  })(MaterialAutocompleteInput)}
                </FormRowItem>
                <FormRowItem lg={3} md={3} sm={6} xs={12}>
                  <DateInput
                    label={messages?.timeCard?.form?.periodEnding}
                    onlyVisibleDay={
                      selectedCompanyDetails?.PayFrequency !== "Monthly"
                        ? selectedCompanyDetails?.PayEnding
                        : "LastDay"
                    }
                    disabled={!selectedCompanyDetails}
                    value={formValues?.periodEnding?.value}
                    error={!pristine && formValues?.periodEnding?.error}
                    onChange={handlePeriodEndingChange}
                    onBlur={handlePeriodEndingBlur}
                  />
                </FormRowItem>
                {selectedCompanyDetails?.departments ? (
                  <FormRowItem lg={3} md={3} sm={6} xs={12}>
                    {connectField("departments", {
                      label: messages?.timeCard?.form?.department,
                      options: deptOptions?.map(mapDepartmentNameToOption),
                      isCreatable: true,
                    })(MaterialAutoCompleteWithAddOption)}
                  </FormRowItem>
                ) : (
                  <FormRowItem lg={3} md={3} sm={6} xs={12}>
                    {connectField("department", {
                      label: messages?.timeCard?.form?.department,
                    })(TextInput)}
                  </FormRowItem>
                )}
                <FormRowItem lg={3} md={3} sm={6} xs={12}>
                  {connectField("position", {
                    label: messages?.timeCard?.form?.position,
                  })(TextInput)}
                </FormRowItem>
                {/* eslint-disable-next-line react/jsx-no-useless-fragment */}
                <>
                  {customFields?.length > 0 &&
                    customFields?.map((field: CustomField) => {
                      return Boolean(field?.hide) ? null : (
                        <FormRowItem lg={3} md={3} sm={6} xs={12}>
                          <CustomFieldComponent
                            field={field}
                            connectField={connectField}
                          />
                        </FormRowItem>
                      );
                    })}
                </>
              </FormRow>
            </OutlinedContainer>

            {!isMobile ? (
              <>
                <FormRow display="flex" justifyContent="flex-end" marginTop={2}>
                  <FixedTitle
                    varient="Fixed12Medium"
                    color={brandColour?.primary100}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "2px",
                      cursor: "pointer",
                      marginRight: "24px",
                    }}
                    onClick={handleImportDailyTimes}
                  >
                    <FileUploadOutlinedIcon style={importIconStyles} />
                    {messages?.timeCard?.dailyTimes}
                  </FixedTitle>
                  <FixedTitle
                    varient="Fixed12Medium"
                    color={brandColour?.primary100}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "2px",
                      cursor: "pointer",
                    }}
                    onClick={handleCopyLastWeeksData}
                  >
                    <ContentCopyIcon style={iconStyles} />
                    {messages?.timeCard?.copyTimes}
                  </FixedTitle>
                </FormRow>
                <FormRow marginBottom={2}>
                  <Table
                    fixPayAsAndCustomNoteUI
                    payAsIndex={payAsIndex}
                    noteIndex={noteIndex}
                    emptyMessage={
                      !formValues?.periodEnding?.value &&
                      "Please select period ending date."
                    }
                    disableTableSorting
                    editableFields={[
                      ...(hasUnitsAndLocations ? ["Unit", "Locations"] : []),
                      "Start",
                      "TotalMBDed",
                      "Finish",
                      "Payas",
                      "Note",
                    ]}
                    data={weekData || []}
                    actions={[
                      {
                        id: "edit",
                        component: (
                          <EditOutlineIcon
                            style={{
                              ...iconStyles,
                              color: brandColour?.primary100,
                            }}
                          />
                        ),
                        onClick: (row, _, rowIndex) => {
                          showEditForm({
                            data: weekData[rowIndex],
                            rowIndex,
                          });
                        },
                      },
                    ]}
                    specs={[
                      {
                        id: "Date",
                        label: messages?.timeCard?.form?.table?.date,
                        minWidth: "90px",
                        // format: (row: Date) => row,
                      },
                      {
                        id: "Day",
                        label: messages?.timeCard?.form?.table?.day,
                        minWidth: "80px",
                      },
                      ...(hasUnitsAndLocations
                        ? [
                            {
                              id: "Unit",
                              label: "Unit",
                              minWidth: "100px",
                              format: (
                                row: string,
                                fieldKey: keyof DailyTime,
                                rowIndex: number,
                              ) => unitDropListField(row, fieldKey, rowIndex),
                            },
                            {
                              id: "Locations",
                              label: "Locations",
                              minWidth: "120px",
                              format: (
                                row: string,
                                fieldKey: keyof DailyTime,
                                rowIndex: number,
                              ) =>
                                locationDropListField(row, fieldKey, rowIndex),
                            },
                            ...(showCamCallWrap
                              ? [
                                  {
                                    id: "CamCall",
                                    label: "Cam Call",
                                    minWidth: "55px",
                                    format: (
                                      row: string,
                                      fieldKey: keyof DailyTime,
                                      rowIndex: number,
                                    ) =>
                                      weekData?.[rowIndex]?.CamCall &&
                                      weekData[rowIndex].CamCall !== "00:00"
                                        ? timeInputField(
                                            row,
                                            fieldKey,
                                            rowIndex,
                                            true,
                                          )
                                        : "",
                                  },
                                  {
                                    id: "CamWrap",
                                    label: "Cam Wrap",
                                    minWidth: "55px",
                                    format: (
                                      row: string,
                                      fieldKey: keyof DailyTime,
                                      rowIndex: number,
                                    ) =>
                                      weekData?.[rowIndex]?.CamWrap &&
                                      weekData[rowIndex].CamWrap !== "00:00"
                                        ? timeInputField(
                                            row,
                                            fieldKey,
                                            rowIndex,
                                            true,
                                          )
                                        : "",
                                  },
                                ]
                              : []),
                          ]
                        : []),
                      ...(selectedCompanyDetails?.TravelToHide !== true
                        ? [
                            {
                              id: "Travel1",
                              label: "Travel To",
                              minWidth: "55px",
                              format: (
                                row: string,
                                fieldKey: keyof DailyTime,
                                rowIndex: number,
                              ) =>
                                timeInputField(
                                  row,
                                  fieldKey,
                                  rowIndex,
                                  weekData?.[rowIndex]?.Payas ===
                                    "Did Not Work",
                                ),
                            },
                          ]
                        : []),
                      {
                        id: "Start",
                        label: messages?.timeCard?.form?.table?.start,
                        minWidth: "55px",
                        format: (
                          row: string,
                          fieldKey: keyof DailyTime,
                          rowIndex: number,
                        ) =>
                          timeInputField(
                            row,
                            fieldKey,
                            rowIndex,
                            weekData?.[rowIndex]?.Payas === "Did Not Work",
                          ),
                      },
                      {
                        id: "TotalMBDed",
                        label: messages?.timeCard?.form?.table?.meal,
                        minWidth: "55px",
                        format: (
                          row: string,
                          fieldKey: keyof DailyTime,
                          rowIndex: number,
                        ) =>
                          timeInputField(
                            row,
                            fieldKey,
                            rowIndex,
                            weekData?.[rowIndex]?.Payas === "Did Not Work" ||
                              selectedCompanyDetails?.allowMealBreak ||
                              mealBreakLockedRows[rowIndex] === 1,
                          ),
                      },
                      {
                        id: "Finish",
                        label: messages?.timeCard?.form?.table?.finish,
                        minWidth: "55px",
                        format: (
                          row: string,
                          fieldKey: keyof DailyTime,
                          rowIndex: number,
                        ) =>
                          timeInputField(
                            row,
                            fieldKey,
                            rowIndex,
                            weekData?.[rowIndex]?.Payas === "Did Not Work",
                          ),
                      },
                      ...(selectedCompanyDetails?.TravelFromHide !== true
                        ? [
                            {
                              id: "Travel2",
                              label: "Travel From",
                              minWidth: "55px",

                              format: (
                                row: string,
                                fieldKey: keyof DailyTime,
                                rowIndex: number,
                              ) =>
                                timeInputField(
                                  row,
                                  fieldKey,
                                  rowIndex,
                                  weekData?.[rowIndex]?.Payas ===
                                    "Did Not Work",
                                ),
                            },
                          ]
                        : []),
                      {
                        id: "TotalHours",
                        label: messages?.timeCard?.form?.table?.hours,
                        minWidth: "55px",
                      },
                      {
                        id: "Payas",
                        label: messages?.timeCard?.form?.table?.payAs,
                        format: (
                          row: string,
                          fieldKey: keyof DailyTime,
                          rowIndex: number,
                        ) => dropListField(row, fieldKey, rowIndex),
                      },
                      {
                        id: "customNote",
                        label: messages?.timeCard?.form?.table?.note,
                        format: (
                          row: string,
                          fieldKey: keyof DailyTime,
                          rowIndex: number,
                        ) => textInputField(row, fieldKey, rowIndex, true),
                      },
                    ]}
                  />
                </FormRow>
                <FormRow
                  marginBottom={3}
                  justifyContent="flex-end"
                  columnGap={1}
                >
                  <FixedTitle varient="Fixed14Regular">
                    {messages?.timeCard?.todalHrs}
                  </FixedTitle>
                  <FixedTitle varient="Fixed14Bold">
                    {getTotalHours()}
                  </FixedTitle>
                </FormRow>
              </>
            ) : (
              <OutlinedContainer
                padding="24px 16px"
                styles={{ cursor: "pointer" }}
                onClick={() => {
                  setScreenIndex({
                    screen1: false,
                    screen2: true,
                    screen3: false,
                  });
                }}
              >
                <Row>
                  <Column>
                    <StyledHeading
                      fontWeight={fontWeight?.semiBold}
                      fontSize={fontSize?.h5}
                      lineHeight="21px"
                    >
                      {messages?.timeCard?.todalHrs} {getTotalHours()}
                    </StyledHeading>
                    <FixedTitle
                      varient="Fixed12Regular"
                      color={greyScaleColour?.grey100}
                    >
                      The above hours are total working hours
                    </FixedTitle>
                  </Column>
                  <KeyboardArrowRightIcon style={rightArrowStyles} />
                </Row>
              </OutlinedContainer>
            )}

            <OutlinedContainer
              borderRadius="0"
              padding="24px 0"
              noBorder
              styles={{
                borderTop: `1px solid ${brandColour?.primary10}`,
              }}
            >
              <FormRow>
                <StyledHeading
                  fontSize={fontSize?.h4}
                  fontWeight={fontWeight?.semiBold}
                  lineHeight="26.4px"
                >
                  {messages?.timeCard?.form?.attachment}
                </StyledHeading>
              </FormRow>
              <Grid container>
                {connectField("fileUpload", {
                  files,
                  setFiles,
                  uploadFile,
                  setUploadFile,
                  acceptedFiles: ".pdf, image/png, image/jpg, image/jpeg",
                  isPictureView: true,
                  multiple: true,
                  row: !isMobile,
                  showLoading,
                  fullWidth: false,
                  showProgress: true,
                  disabled:
                    submitting || submittingPreview || submittingTimeCard,
                  allowFileClick: true,
                  warningSize: 7,
                  openAttachmentOnClick:
                    (isUpdateForm || isImport) && openAttachmentOnClick,
                })(DragAndDrop)}
              </Grid>
            </OutlinedContainer>
            {submitError && (
              <FormRow>
                <FormRowItem>
                  <FormError message={submitError} />
                </FormRowItem>
              </FormRow>
            )}
            <Grid container justifyContent="space-between" marginBottom={3}>
              <Grid item>
                <Grid container spacing={2}>
                  <Grid item>
                    <Button
                      variant="outlined"
                      color="primary"
                      size="large"
                      // type="submit"
                      onClick={handleSubmit(onSaveTimeCard, null, true)}
                      disabled={submitting}
                      buttonColor={isMobile && brandColour?.primary100}
                      label={
                        messages?.general?.[
                          isImport || isUpdateForm ? "update" : "save"
                        ]
                      }
                    />
                  </Grid>
                  {!isMobile && (
                    <Grid item>
                      <Button
                        variant="outlined"
                        buttonColor={brand?.black}
                        color="primary"
                        size="large"
                        onClick={() => reduxDispatch(goBack())}
                        label={messages?.general?.cancel}
                      />
                    </Grid>
                  )}
                </Grid>
              </Grid>
              {/* Right Buttons */}
              <Grid item>
                <Grid container spacing={2}>
                  <Grid item>
                    <Button
                      onClick={handleSubmit(handlePreviewClick, hasErrorToast)}
                      variant="outlined"
                      color="primary"
                      size="large"
                      type="submit"
                      buttonColor={
                        isMobile
                          ? greyScaleColour?.black100
                          : !submittingPreview && brandColour?.primary100
                      }
                      disabled={submittingPreview}
                      label={messages?.general?.preview}
                    />
                  </Grid>
                  <Grid item>
                    <Button
                      onClick={handleSubmit(
                        isMobile
                          ? () => setSubmitTimeCardScreen(true)
                          : handleShowDigitalForm,
                        hasErrorToast,
                      )}
                      variant="outlined"
                      color="primary"
                      size="large"
                      disabled={submittingTimeCard}
                      label={messages?.general?.submit}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Form>
        </Card>
        <Modal
          icon={<TextSnippetOutlinedIcon />}
          show={digitalFormVisibility}
          heading="Digital timesheet"
          onClose={hideDigitalForm}
          fitContent
        >
          <DigitalTimeSheet
            onCancel={hideDigitalForm}
            onSubmit={(submitData: { email: string }) =>
              new Promise<void>((resolve, reject) => {
                try {
                  setSubmittingTimeCard(true);
                  onSubmitTimeCard(submitData?.email);
                  resolve();
                } catch (error) {
                  reject(error);
                }
              })
            }
            submittingTimeCard={submittingTimeCard}
            email={selectedCompanyBriefDetails?.EmailAddress}
          />
        </Modal>
        <Modal
          chipLabel={`${editFormMetadata?.data?.Date} | ${editFormMetadata?.data?.Day}`}
          icon={<EditOutlineIcon />}
          show={editFormVisibility}
          heading="Update time"
          onClose={() => {
            hideEditForm();
            setYesterdayTimings(null);
            onCancelEditForm();
          }}
          subHeadingLink
          fitContent
          maxHeight={`${height * 0.75}px`}
          handleHeadingClick={handleCopyYesterdayTimings}
        >
          <UpdateTimeForm
            onCancel={() => {
              hideEditForm();
              setYesterdayTimings(null);
              onCancelEditForm();
            }}
            onSuccess={(updatedDay: DailyTime) => {
              hideEditForm();
              setWeekData((prevWeekData: DailyTime[]) => {
                const newWeekData = [...prevWeekData];
                newWeekData[editFormMetadata?.rowIndex] = updatedDay;
                return newWeekData;
              });
            }}
            passedData={editFormMetadata}
            yesterdayTimings={yesterdayTimings}
            setYesterdayTimings={setYesterdayTimings}
            companyDetails={selectedCompanyDetails}
            setMealBreakLockedRows={setMealBreakLockedRows}
            rowIndex={editFormMetadata?.rowIndex}
            selectedLocations={selectedLocations}
            locationsForUnit={locationsForUnit}
            unitListWithEmpty={unitListWithEmpty}
            unitsByRange={unitsByRange}
            date={date}
            weekDateData={weekData?.[editFormMetadata?.rowIndex || 0]}
            payAsLockedRows={payAsLockedRows}
            setPayAsLockedRows={setPayAsLockedRows}
          />
        </Modal>
        <Modal
          show={showImportPopup}
          heading="Existing Timecard Found"
          fitContent
          onClose={handleCancelImport}
        >
          <div
            style={{
              padding: "12px 16px",
              maxWidth: 460,
              fontSize: "14px",
              lineHeight: "1.4",
            }}
          >
            <p style={{ margin: "4px 0 8px 0" }}>
              You have a previously submitted Timecard for{" "}
              <strong>{pendingImportCard?.Company?.[0]?.Name}</strong> and
              Period Ending{" "}
              <strong>
                {moment(
                  pendingImportCard?.PeriodEnding,
                  PERIOD_ENDING_DATE_FORMATS,
                ).format(PERIOD_ENDING_DISPLAY_DATE_FORMAT)}
              </strong>
              .
            </p>

            <p style={{ margin: "0 0 8px 0" }}>
              {messages?.company?.existingTimeCardForm?.subHeading}
            </p>

            <p style={{ margin: "0 0 12px 0", color: "#555" }}>
              {messages?.company?.existingTimeCardForm?.paraMessage}
            </p>

            <Grid
              container
              spacing={2}
              justifyContent="flex-end"
              style={{ marginTop: 8 }}
            >
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  label="Cancel"
                  onClick={handleCancelImport}
                />
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  label="Confirm"
                  onClick={handleConfirmImport}
                />
              </Grid>
            </Grid>
          </div>
        </Modal>
      </Container>
    );
  };

  if (submitTimeCardScreen) {
    return (
      <DigitalTimeSheetMobile
        handleTimeCardSubmit={(submitData: { email: string }) =>
          new Promise<void>((resolve, reject) => {
            try {
              setSubmittingTimeCard(true);
              onSubmitTimeCard(submitData?.email);
              resolve();
            } catch (error) {
              toast(<Toast type="error" text={error} />);
            }
          })
        }
        submittingTimeCard={submittingTimeCard}
        email={selectedCompanyBriefDetails?.EmailAddress}
        setSubmitTimeCardScreen={setSubmitTimeCardScreen}
      />
    );
  }

  if (screenIndex?.screen1) {
    return Screen1();
  }

  return (
    <TimeCardTable
      weekData={weekData}
      companyDetails={selectedCompanyDetails}
      setScreenIndex={setScreenIndex}
      screenIndex={screenIndex}
      setWeekData={setWeekData}
      handleCopyLastWeeksData={handleCopyLastWeeksData}
      handleImportDailyTimes={handleImportDailyTimes}
      unitsByRange={unitsByRange}
      payAsLockedRows={payAsLockedRows}
      setPayAsLockedRows={setPayAsLockedRows}
    />
  );
};

export default AddTimeCard;
